import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import WhatsAppCaso from "../Mensaje/WhatsAppCaso";
import { fetchPerfilActual } from "../../Utils/PerfilActual";
import { Grid, IconButton as MuiIconButton, Chip } from "@mui/material";
import { etiquetaTipoCaso } from "../../Utils/TipoCaso";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import { getData, postData, pathData, deleteData } from "../../Utils/Http/api";
import getCookie from "../../Utils/getcookies";
import setCookie from "../../Utils/setcookie";
import { fetchOrganismos } from "../../Utils/Organismo";
import { fetchUsuarios } from "../../Utils/Usuarios";
import { fetchSujetoContactoTipos } from "../../Utils/SujetoContactoTipo";
import { fetchSujetoContactoOrigenes } from "../../Utils/SujetoContactoOrigen";
import { fetchSujetoContactoPrioridades } from "../../Utils/SujetoContactoPrioridad";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { Phone, Email, Edit as EditIcon, Delete as DeleteIcon, Add, Close as CloseIcon, Print, EmailOutlined, Notifications, CheckCircle, RadioButtonUnchecked, AccessAlarm, Schedule, EventAvailable, SwapHoriz } from '@mui/icons-material';
import { ListTask, PersonCheck, CalendarEvent } from 'react-bootstrap-icons';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { List, ListItem, ListItemText, Divider } from '@mui/material';
import Switch from '@mui/material/Switch';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import * as XLSX from 'xlsx-js-style';
import { FileDownload } from '@mui/icons-material';
import MDInput from "../../controls/MDInput";

dayjs.locale('es');

// Componente para hacer los diálogos arrastrables
function PaperComponent(props) {
    return (
        <Draggable
            handle="[id^='draggable-']"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

function JudCasoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });

    // Estados para alertas
    const [alertas, setAlertas] = useState([]);
    const [alertasRojas, setAlertasRojas] = useState([]);
    const [alertasAmarillas, setAlertasAmarillas] = useState([]);
    const [alertasVerdes, setAlertasVerdes] = useState([]);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [alertDialogType, setAlertDialogType] = useState(''); // 'rojo', 'amarillo', 'verde'
    const [alertDialogData, setAlertDialogData] = useState([]);
    const [alertDialogDataOriginal, setAlertDialogDataOriginal] = useState([]); // Datos originales sin filtrar
    const [alertFiltroNombre, setAlertFiltroNombre] = useState("");
    const [alertFiltroIdentificacion, setAlertFiltroIdentificacion] = useState("");
    const [alertFiltroExpediente, setAlertFiltroExpediente] = useState("");

    // Combos
    const [organismos, setOrganismos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [estados, setEstados] = useState([]);
    const [subEstados] = useState([
        { id: 1, label: "GESTION" },
        { id: 2, label: "CAUTELAR" },
        { id: 3, label: "PROCESAL" }
    ]);

    // Filtros - cargar desde cookies
    const [filtroOrganismo, setFiltroOrganismo] = useState(() => {
        const cookie = getCookie("judCasoFiltroIdOrganismo");
        return cookie ? parseInt(cookie) : null;
    });
    const [filtroUsuario, setFiltroUsuario] = useState(() => {
        const cookie = getCookie("judCasoFiltroIdUsuario");
        return cookie ? parseInt(cookie) : null;
    });
    const [filtroNombreSujeto, setFiltroNombreSujeto] = useState(() => getCookie("judCasoFiltroNombreSujeto") || "");
    const [filtroIdentificacion, setFiltroIdentificacion] = useState(() => getCookie("judCasoFiltroIdentificacion") || "");
    const [filtroSubEstado, setFiltroSubEstado] = useState(() => {
        const cookie = getCookie("judCasoFiltroIdSubEstado");
        return cookie ? parseInt(cookie) : null;
    });
    const [filtroEstado, setFiltroEstado] = useState(() => {
        const cookie = getCookie("judCasoFiltroIdEstado");
        return cookie ? parseInt(cookie) : null;
    });
    const [filtroIdJudCaso, setFiltroIdJudCaso] = useState(() => getCookie("judCasoFiltroIdJudCaso") || "");
    const [filtroNroExpediente, setFiltroNroExpediente] = useState(() => getCookie("judCasoFiltroNroExpediente") || "");
    const [filtroObjetos, setFiltroObjetos] = useState(() => getCookie("judCasoFiltroObjetos") || "");
    const [filtroCantObjetosDesde, setFiltroCantObjetosDesde] = useState(() => getCookie("judCasoFiltroCantObjetosDesde") || "");
    const [filtroCantObjetosHasta, setFiltroCantObjetosHasta] = useState(() => getCookie("judCasoFiltroCantObjetosHasta") || "");
    const [filtroMontoDesde, setFiltroMontoDesde] = useState(() => getCookie("judCasoFiltroMontoDesde") || "");
    const [filtroMontoHasta, setFiltroMontoHasta] = useState(() => getCookie("judCasoFiltroMontoHasta") || "");
    const [filtroFechaDesde, setFiltroFechaDesde] = useState(() => {
        const cookie = getCookie("judCasoFiltroFechaDesde");
        return cookie ? dayjs(cookie) : dayjs().subtract(30, 'day');
    });
    const [filtroFechaHasta, setFiltroFechaHasta] = useState(() => {
        const cookie = getCookie("judCasoFiltroFechaHasta");
        return cookie ? dayjs(cookie) : dayjs().add(30, 'day');
    });
    const [filtroPoseeContactos, setFiltroPoseeContactos] = useState(() => {
        const cookie = getCookie("judCasoFiltroPoseeContactos");
        return cookie ? { id: parseInt(cookie), label: cookie === "0" ? "Todos" : cookie === "1" ? "Si" : "No" } : { id: 0, label: "Todos" };
    });
    const [filtroPoseeCuit, setFiltroPoseeCuit] = useState(() => {
        const cookie = getCookie("judCasoFiltroPoseeCuit");
        return cookie ? { id: parseInt(cookie), label: cookie === "0" ? "Todos" : cookie === "1" ? "Si" : "No" } : { id: 0, label: "Todos" };
    });
    const [filtroLimiteRegistros, setFiltroLimiteRegistros] = useState(100);
    const [perfilActual, setPerfilActual] = useState({ limiteRegistros: 100, puedeReasignarCasos: false });
    const idUsuarioLogueado = parseInt(localStorage.getItem("iduserlogueado")) || 0;

    // El límite de registros lo define el perfil del usuario (pantalla Perfiles).
    useEffect(() => {
        fetchPerfilActual().then((perfil) => {
            setPerfilActual(perfil);
            setFiltroLimiteRegistros(perfil.limiteRegistros);
        });
    }, []);

    // Dialog Contactos
    const [contactosDialog, setContactosDialog] = useState({
        open: false,
        idSujeto: null,
        nombreSujeto: "",
        contactos: []
    });

    // Catálogos para contactos
    const [tiposContacto, setTiposContacto] = useState([]);
    const [origenesContacto, setOrigenesContacto] = useState([]);
    const [prioridadesContacto, setPrioridadesContacto] = useState([]);

    // Edit Contacto Dialog
    const [editContactoDialog, setEditContactoDialog] = useState({
        open: false,
        contacto: null,
        idSujeto: null,
        valorContacto: "",
        selectedTipo: null,
        selectedOrigen: null,
        selectedPrioridad: null,
        saving: false
    });

    // Add Contacto Dialog
    const [addContactoDialog, setAddContactoDialog] = useState({
        open: false,
        idSujeto: null,
        valorContacto: "",
        selectedTipo: null,
        selectedOrigen: null,
        selectedPrioridad: null,
        saving: false
    });

    // Delete Contacto Dialog
    const [deleteContactoDialog, setDeleteContactoDialog] = useState({
        open: false,
        idSujetoContacto: null
    });

    // Edit Expediente Fields Dialog
    const [editExpedienteDialog, setEditExpedienteDialog] = useState({
        open: false,
        idJudCaso: null,
        fieldName: "",
        fieldLabel: "",
        fieldValue: "",
        fieldType: "string", // "string" o "decimal"
        fieldEstado: 0, // Para campos que tienen estado (0 o 1)
        saving: false
    });

    // Cambiar Gestor Dialog
    const [cambiarGestorDialog, setCambiarGestorDialog] = useState({
        open: false,
        idJudCaso: null,
        idUsuarioActual: null,
        usuarioActual: "",
        selectedUsuario: null,
        guardando: false
    });

    // Dialog Objetos
    const [objetosDialog, setObjetosDialog] = useState({ open: false, contenido: "" });

    // Dialog Seguimiento
    const [seguimientoDialog, setSeguimientoDialog] = useState({
        open: false,
        idJudCaso: null,
        eventos: [],
        loading: false
    });

    // Dialog Mail
    const [mailDialog, setMailDialog] = useState({
        open: false,
        idJudCaso: null,
        para: "",
        cc: "",
        asunto: "",
        cuerpo: "",
        enviando: false
    });

    // Dialog Agregar Evento
    const [eventoDialog, setEventoDialog] = useState({
        open: false,
        idJudCaso: null,
        idSujeto: null,
        nombreSujeto: "",
        observaciones: "",
        tipoEvento: null,
        subEstado: null,
        estado: null,
        guardando: false,
        agendarLlamada: false,
        fechaAgenda: dayjs(),
        observacionesAgenda: ""
    });

    const [tiposEventoJud, setTiposEventoJud] = useState([]);

    // Dialog Agenda
    const [agendaDialog, setAgendaDialog] = useState({
        open: false,
        idJudCaso: null,
        idSujeto: null,
        nombreSujeto: "",
        fecha: dayjs(),
        observaciones: ""
    });
    const [guardandoAgenda, setGuardandoAgenda] = useState(false);

    // Notificaciones Agenda
    const [agendasNoVistas, setAgendasNoVistas] = useState(0);
    const [notificacionesDialog, setNotificacionesDialog] = useState(false);
    const [agendasHoy, setAgendasHoy] = useState([]);
    const [agendasFiltradas, setAgendasFiltradas] = useState([]);
    const [loadingAgendas, setLoadingAgendas] = useState(false);
    const [agendaFilters, setAgendaFilters] = useState({
        fechaDesde: dayjs(),
        fechaHasta: dayjs(),
        nombreSujeto: ""
    });

    useEffect(() => {
        const loadOrganismos = async () => {
            try {
                const data = await fetchOrganismos();
                setOrganismos(data.map(o => ({ id: o.idOrganismo, label: o.descripcion, activo: o.activo })));
            } catch (ex) {
                console.error('Error cargando organismos', ex);
            }
        };
        loadOrganismos();
    }, []);

    useEffect(() => {
        const loadUsuarios = async () => {
            try {
                const data = await fetchUsuarios();
                setUsuarios(data.map(u => ({ id: u.idUsuario, label: u.nombreCompleto || u.usuario, activo: u.activo })));
            } catch (ex) {
                console.error('Error cargando usuarios', ex);
            }
        };
        loadUsuarios();
    }, []);

    const fetchEstados = async () => {
        try {
            const res = await getData('/JudEstadoListar', { estado: "", subEstado: "" });
            const list = res?.value || [];
            setEstados(list.map(e => ({
                id: e.idJudEstado,
                label: `${e.estado} (${e.subEstado})`,
                estado: e.estado,
                subEstado: e.subEstado
            })));
        } catch (ex) {
            console.error('Error cargando estados', ex);
        }
    };

    // Cargar catálogos de contactos una sola vez al inicio
    useEffect(() => {
        const loadCatalogosContactos = async () => {
            try {
                const tipos = await fetchSujetoContactoTipos();
                const origenes = await fetchSujetoContactoOrigenes();
                const prioridades = await fetchSujetoContactoPrioridades();

                const tiposList = (tipos || []).map(t => ({ id: t.idSujetoContactoTipo, label: t.descripcion, activo: t.activo }));
                const origenesList = (origenes || []).map(o => ({ id: o.idSujetoContactoOrigen, label: o.descripcion, activo: o.activo }));
                const prioridadesList = (prioridades || []).map(p => ({ id: p.idSujetoPrioridadContacto, label: p.descripcion, activo: p.activo, orden: p.orden }));

                setTiposContacto(tiposList);
                setOrigenesContacto(origenesList);
                setPrioridadesContacto(prioridadesList);
            } catch (ex) {
                console.error('Error cargando catálogos de contactos', ex);
            }
        };
        loadCatalogosContactos();
    }, []);

    const fetchData = async (idJudCasoOverride = null) => {
        
        setLoading(true);
        try {
            const params = {
                idOrganismo: filtroOrganismo?.id || 0,
                idUsuario: filtroUsuario?.id || 0,
                nombreSujeto: filtroNombreSujeto || "",
                identificacion: filtroIdentificacion || "",
                objetos: filtroObjetos || "",
                etapa: filtroSubEstado?.label || "",
                idJudEstado: filtroEstado?.id || 0,
                idJudCaso: idJudCasoOverride !== null ? parseInt(idJudCasoOverride) : (parseInt(filtroIdJudCaso) || 0),
                nroExpediente: filtroNroExpediente || "",
                cantidadObjetosDesde: parseInt(filtroCantObjetosDesde) || 0,
                cantidadObjetosHasta: parseInt(filtroCantObjetosHasta) || 0,
                montoDesde: parseFloat(filtroMontoDesde) || 0,
                montoHasta: parseFloat(filtroMontoHasta) || 0,
                fechaEventoDesde: filtroFechaDesde ? filtroFechaDesde.format('YYYY-MM-DD') + 'T00:00:00' : "",
                fechaEventoHasta: filtroFechaHasta ? filtroFechaHasta.format('YYYY-MM-DD') + 'T23:59:59' : "",
                poseeContactos: filtroPoseeContactos?.id ?? 0,
                poseeCuit: filtroPoseeCuit?.id ?? 0,
                limiteRegistros: parseInt(filtroLimiteRegistros) || 100
            };

            const res = await postData('/JudCasoListar', params);
            const list = res?.value || [];

            const newColumns = [
                { Header: 'Caso', accessor: 'caso', align: 'left', width: '30%' },
                { Header: 'Estados', accessor: 'estados', align: 'left', width: '18%' },
                { Header: 'Gestor', accessor: 'gestor', align: 'left', width: '12%' },
                { Header: 'Expediente', accessor: 'expediente', align: 'left', width: '15%' },
                { Header: "Acciones", accessor: "acciones", align: "center", width: "25%" },
            ];

            const data = list.map(item => generarFilaTabla(item));

            /* Código anterior - ahora usa generarFilaTabla */

            setColumns(newColumns);
            setRows(data);
            setList(list);
        } catch (ex) {
            console.error('Error cargando casos judiciales', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los casos judiciales', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEstados();
        cargarAgendasHoy();

        // Recargar agendas cada 5 minutos
        const interval = setInterval(() => {
            cargarAgendasHoy();
        }, 300000); // 5 minutos

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect para regenerar rows cuando list cambia
    useEffect(() => {
        if (list && list.length > 0) {
            const data = list.map(item => generarFilaTabla(item));
            setRows(data);
        }
    }, [list]);

    useEffect(() => {
        if (seguimientoDialog.open) {
            const fetchEventos = async () => {
                try {
                    const res = await postData(`/JudEventoListar?idJudCaso=${seguimientoDialog.idJudCaso}`, {});
                    const eventos = res?.value || [];
                    setSeguimientoDialog(prev => ({ ...prev, eventos, loading: false }));
                } catch (error) {
                    console.error('Error cargando eventos:', error);
                    setSeguimientoDialog(prev => ({ ...prev, loading: false }));
                }
            };
            fetchEventos();
        }
    }, [seguimientoDialog.open, seguimientoDialog.idJudCaso]);

    useEffect(() => {
        fetchEstados();
        cargarAgendasHoy();

        // Recargar agendas cada 5 minutos
        const interval = setInterval(() => {
            cargarAgendasHoy();
        }, 300000); // 5 minutos

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cargarAlertas = async () => {
        try {
            const idUsuario = localStorage.getItem("iduserlogueado") || "1";
            const res = await getData(`/JudCasoAlertaListarByIdUsuario?idUsuario=${idUsuario}`);
            if (res?.isSuccess && res?.value) {
                const alertasData = res.value;
                setAlertas(alertasData);

                // Agrupar alertas por días restantes
                const hoy = dayjs();
                const rojas = [];
                const amarillas = [];
                const verdes = [];

                alertasData.forEach(alerta => {
                    const fechaPlazo = dayjs(alerta.fechaPlazo);
                    const diasRestantes = fechaPlazo.diff(hoy, 'day');

                    if (diasRestantes < 0) {
                        // 🔴 Rojo - Vencido: El evento ya superó su fecha de vencimiento
                        rojas.push(alerta);
                    } else if (diasRestantes >= 0 && diasRestantes <= 1) {
                        // 🟡 Amarillo - Vence hoy/próximo a vencer: Falta 1 día o menos (hoy = 0, mañana = 1)
                        amarillas.push(alerta);
                    } else {
                        // 🟢 Verde - En plazo: Faltan más de 2 días (diasRestantes > 1)
                        verdes.push(alerta);
                    }
                });

                setAlertasRojas(rojas);
                setAlertasAmarillas(amarillas);
                setAlertasVerdes(verdes);
            }
        } catch (error) {
            console.error('Error cargando alertas:', error);
        }
    };

    const handleBuscar = () => {
        // Guardar filtros en cookies (válidas por 30 días = 43200 minutos)
        setCookie("judCasoFiltroIdOrganismo", filtroOrganismo || "", 43200);
        setCookie("judCasoFiltroIdUsuario", filtroUsuario || "", 43200);
        setCookie("judCasoFiltroNombreSujeto", filtroNombreSujeto, 43200);
        setCookie("judCasoFiltroIdentificacion", filtroIdentificacion, 43200);
        setCookie("judCasoFiltroIdSubEstado", filtroSubEstado || "", 43200);
        setCookie("judCasoFiltroIdEstado", filtroEstado || "", 43200);
        setCookie("judCasoFiltroIdJudCaso", filtroIdJudCaso, 43200);
        setCookie("judCasoFiltroNroExpediente", filtroNroExpediente, 43200);
        setCookie("judCasoFiltroObjetos", filtroObjetos, 43200);
        setCookie("judCasoFiltroCantObjetosDesde", filtroCantObjetosDesde, 43200);
        setCookie("judCasoFiltroCantObjetosHasta", filtroCantObjetosHasta, 43200);
        setCookie("judCasoFiltroMontoDesde", filtroMontoDesde, 43200);
        setCookie("judCasoFiltroMontoHasta", filtroMontoHasta, 43200);
        setCookie("judCasoFiltroFechaDesde", filtroFechaDesde ? filtroFechaDesde.format('YYYY-MM-DD') : "", 43200);
        setCookie("judCasoFiltroFechaHasta", filtroFechaHasta ? filtroFechaHasta.format('YYYY-MM-DD') : "", 43200);
        setCookie("judCasoFiltroPoseeContactos", filtroPoseeContactos?.id?.toString() || "0", 43200);
        setCookie("judCasoFiltroPoseeCuit", filtroPoseeCuit?.id?.toString() || "0", 43200);
        sessionStorage.removeItem("casos_judiciales_table");
        fetchData();
        cargarAlertas();
    };

    const handleOpenAlertDialog = (tipo) => {
        setAlertDialogType(tipo);
        let datos = [];
        if (tipo === 'rojo') {
            datos = alertasRojas;
        } else if (tipo === 'amarillo') {
            datos = alertasAmarillas;
        } else if (tipo === 'verde') {
            datos = alertasVerdes;
        }
        setAlertDialogData(datos);
        setAlertDialogDataOriginal(datos);
        // Limpiar filtros
        setAlertFiltroNombre("");
        setAlertFiltroIdentificacion("");
        setAlertFiltroExpediente("");
        setOpenAlertDialog(true);
    };

    const handleCloseAlertDialog = () => {
        setOpenAlertDialog(false);
        setAlertDialogData([]);
        setAlertDialogDataOriginal([]);
        setAlertDialogType('');
        setAlertFiltroNombre("");
        setAlertFiltroIdentificacion("");
        setAlertFiltroExpediente("");
    };

    // Filtrado local de alertas en tiempo real
    useEffect(() => {
        if (alertDialogDataOriginal.length === 0) return;
        
        let datosFiltrados = [...alertDialogDataOriginal];
        
        if (alertFiltroNombre) {
            datosFiltrados = datosFiltrados.filter(alerta => 
                (alerta.nombreSujeto || "").toLowerCase().includes(alertFiltroNombre.toLowerCase())
            );
        }
        
        if (alertFiltroIdentificacion) {
            datosFiltrados = datosFiltrados.filter(alerta => 
                (alerta.identificacion || "").toLowerCase().includes(alertFiltroIdentificacion.toLowerCase())
            );
        }
        
        if (alertFiltroExpediente) {
            datosFiltrados = datosFiltrados.filter(alerta => 
                (alerta.expedienteJudicial || "").toLowerCase().includes(alertFiltroExpediente.toLowerCase())
            );
        }
        
        setAlertDialogData(datosFiltrados);
    }, [alertFiltroNombre, alertFiltroIdentificacion, alertFiltroExpediente, alertDialogDataOriginal]);

    const handleFiltrarPorCaso = (idJudCaso) => {
        // Cerrar el dialog
        handleCloseAlertDialog();

        // Establecer el filtro con el ID del caso
        setFiltroIdJudCaso(idJudCaso.toString());

        // Guardar en cookie
        setCookie("judCasoFiltroIdJudCaso", idJudCaso.toString(), 43200);

        // Ejecutar búsqueda pasando directamente el ID
        fetchData(idJudCaso);
        cargarAlertas();
    };

    const handleLimpiar = () => {
        // Limpiar cookies
        setCookie("judCasoFiltroIdOrganismo", "", -1);
        setCookie("judCasoFiltroIdUsuario", "", -1);
        setCookie("judCasoFiltroNombreSujeto", "", -1);
        setCookie("judCasoFiltroIdentificacion", "", -1);
        setCookie("judCasoFiltroIdSubEstado", "", -1);
        setCookie("judCasoFiltroIdEstado", "", -1);
        setCookie("judCasoFiltroIdJudCaso", "", -1);
        setCookie("judCasoFiltroNroExpediente", "", -1);
        setCookie("judCasoFiltroObjetos", "", -1);
        setCookie("judCasoFiltroCantObjetosDesde", "", -1);
        setCookie("judCasoFiltroCantObjetosHasta", "", -1);
        setCookie("judCasoFiltroMontoDesde", "", -1);
        setCookie("judCasoFiltroMontoHasta", "", -1);
        setCookie("judCasoFiltroFechaDesde", "", -1);
        setCookie("judCasoFiltroFechaHasta", "", -1);
        setCookie("judCasoFiltroPoseeContactos", "", -1);
        setCookie("judCasoFiltroPoseeCuit", "", -1);

        // Resetear todos los filtros
        setFiltroOrganismo(null);
        setFiltroUsuario(null);
        setFiltroNombreSujeto("");
        setFiltroIdentificacion("");
        setFiltroSubEstado(null);
        setFiltroEstado(null);
        setFiltroIdJudCaso("");
        setFiltroNroExpediente("");
        setFiltroObjetos("");
        setFiltroCantObjetosDesde("");
        setFiltroCantObjetosHasta("");
        setFiltroMontoDesde("");
        setFiltroMontoHasta("");
        setFiltroFechaDesde(dayjs().subtract(30, 'day'));
        setFiltroFechaHasta(dayjs().add(30, 'day'));
        setFiltroPoseeContactos({ id: 0, label: "Todos" });
        setFiltroPoseeCuit({ id: 0, label: "Todos" });
        setFiltroLimiteRegistros(perfilActual.limiteRegistros);

        // Limpiar resultados
        setList([]);
        setRows([]);
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    // Handlers para Dialog Objetos
    const handleOpenObjetosDialog = (objetos) => {
        setObjetosDialog({ open: true, contenido: objetos });
    };

    const handleCloseObjetosDialog = () => {
        setObjetosDialog({ open: false, contenido: "" });
    };

    // Handlers para Dialog Seguimiento
    const handleVerSeguimiento = async (idJudCaso) => {
        setSeguimientoDialog({ open: true, idJudCaso, eventos: [], loading: true });

        try {
            const res = await getData(`/JudEventoListar?idJudCaso=${idJudCaso}`);
            const eventos = res?.value || [];
            setSeguimientoDialog(prev => ({ ...prev, eventos, loading: false }));
        } catch (error) {
            console.error('Error cargando eventos del caso:', error);
            setSnackbar({ open: true, msg: 'Error al cargar el seguimiento', severity: 'error' });
            setSeguimientoDialog(prev => ({ ...prev, loading: false }));
        }
    };

    const handleCloseSeguimiento = () => {
        setSeguimientoDialog({ open: false, idJudCaso: null, eventos: [], loading: false });
    };

    const handleImprimirSeguimiento = () => {
        const printWindow = window.open('', '_blank');

        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Seguimiento del Caso #${seguimientoDialog.idJudCaso}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    h1 { color: #333; border-bottom: 2px solid #1976d2; padding-bottom: 10px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                    th { background-color: #1976d2; color: white; padding: 12px; text-align: left; font-weight: bold; }
                    td { padding: 10px; border-bottom: 1px solid #ddd; }
                    tr:hover { background-color: #f5f5f5; }
                </style>
            </head>
            <body>
                <h1>Seguimiento del Caso #${seguimientoDialog.idJudCaso}</h1>
                <p><strong>Fecha de impresión:</strong> ${dayjs().format('DD/MM/YYYY HH:mm:ss')}</p>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha/Hora</th>
                            <th>Usuario</th>
                            <th>Tipo Evento</th>
                            <th>Observaciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${seguimientoDialog.eventos.map(evento => `
                            <tr>
                                <td>${dayjs(evento.fecha).format('DD/MM/YYYY HH:mm:ss')}</td>
                                <td>${evento.usuario}</td>
                                <td>${evento.tipoEvento}</td>
                                <td>${evento.observaciones}</td>
                                
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </body>
            </html>
        `;

        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    const handleOpenMailDialog = () => {
        setMailDialog({
            open: true,
            idJudCaso: seguimientoDialog.idJudCaso,
            para: "",
            cc: "",
            asunto: `Seguimiento del Caso #${seguimientoDialog.idJudCaso}`,
            cuerpo: "",
            enviando: false
        });
    };

    const handleCloseMailDialog = () => {
        setMailDialog({
            open: false,
            idJudCaso: null,
            para: "",
            cc: "",
            asunto: "",
            cuerpo: "",
            enviando: false
        });
    };

    const handleEnviarMail = async () => {
        if (!mailDialog.para || !mailDialog.asunto || !mailDialog.cuerpo) {
            setSnackbar({ open: true, msg: "Debe completar Para, Asunto y Cuerpo del correo", severity: "warning" });
            return;
        }

        setMailDialog(prev => ({ ...prev, enviando: true }));

        try {
            const payload = {
                idCaso: mailDialog.idJudCaso,
                para: mailDialog.para,
                cc: mailDialog.cc || "",
                asunto: mailDialog.asunto,
                cuerpo: mailDialog.cuerpo
            };

            const response = await postData("/SendMailSeguimientoCasoJudicial", payload);

            if (response?.isSuccess) {
                setSnackbar({ open: true, msg: "Correo enviado correctamente", severity: "success" });
                handleCloseMailDialog();
            } else {
                setSnackbar({ open: true, msg: response?.error || "Error al enviar el correo", severity: "error" });
            }
        } catch (ex) {
            console.error("Error enviando correo:", ex);
            setSnackbar({ open: true, msg: "Error al enviar el correo", severity: "error" });
        } finally {
            setMailDialog(prev => ({ ...prev, enviando: false }));
        }
    };

    // Handlers para Dialog Agregar Evento
    const handleAgregarEvento = async (item) => {
        setEventoDialog({
            open: true,
            idJudCaso: item.idJudCaso,
            idSujeto: item.idSujeto || null,
            nombreSujeto: item.nombreSujeto || "",
            observaciones: "",
            tipoEvento: null,
            subEstado: null,
            estado: null,
            guardando: false,
            agendarLlamada: false,
            fechaAgenda: dayjs(),
            observacionesAgenda: ""
        });
        setTiposEventoJud([]);
    };

    const handleCloseEvento = () => {
        setEventoDialog({
            open: false,
            idJudCaso: null,
            idSujeto: null,
            nombreSujeto: "",
            observaciones: "",
            tipoEvento: null,
            subEstado: null,
            estado: null,
            guardando: false,
            agendarLlamada: false,
            fechaAgenda: dayjs(),
            observacionesAgenda: ""
        });
        setTiposEventoJud([]);
    };

    const handleSubEstadoChange = async (newSubEstado) => {
        setEventoDialog(prev => ({ ...prev, subEstado: newSubEstado, estado: null, tipoEvento: null }));
        setTiposEventoJud([]);
    };

    const handleEstadoChange = async (newEstado) => {
        setEventoDialog(prev => ({ ...prev, estado: newEstado, tipoEvento: null }));

        if (newEstado && eventoDialog.subEstado) {
            try {
                const params = {
                    tipoEvento: "",
                    estado: newEstado.estado,
                    subEstado: eventoDialog.subEstado.subEstado
                };
                const res = await getData('/JudEventoTipoListar', params);
                const list = res?.value || [];
                setTiposEventoJud(list.map(t => ({
                    id: t.idJudEventoTipo,
                    label: t.tipoEvento,
                    plazoEnDias: t.plazoEnDias
                })));
            } catch (ex) {
                console.error("Error cargando tipos de evento:", ex);
                setSnackbar({ open: true, msg: "Error al cargar los tipos de evento", severity: "error" });
            }
        }
    };

    const handleGuardarEvento = async () => {
        if (!eventoDialog.subEstado || !eventoDialog.estado) {
            setSnackbar({ open: true, msg: "Debe seleccionar Sub Estado y Estado", severity: "warning" });
            return;
        }
        if (!eventoDialog.tipoEvento) {
            setSnackbar({ open: true, msg: "Debe seleccionar un tipo de evento", severity: "warning" });
            return;
        }
        if (!eventoDialog.observaciones.trim()) {
            setSnackbar({ open: true, msg: "Las observaciones son requeridas", severity: "warning" });
            return;
        }

        if (eventoDialog.agendarLlamada) {
            if (!eventoDialog.fechaAgenda || !eventoDialog.observacionesAgenda.trim()) {
                setSnackbar({ open: true, msg: "Debe completar fecha y observaciones de la agenda", severity: "warning" });
                return;
            }
        }

        setEventoDialog(prev => ({ ...prev, guardando: true }));

        try {
            const payloadEvento = {
                idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
                idJudEventoTipo: eventoDialog.tipoEvento.id,
                observaciones: eventoDialog.observaciones,
                idJudCaso: eventoDialog.idJudCaso,
                idJudEstado: eventoDialog.estado.id,
                idJudSubEstado: eventoDialog.subEstado.id
            };

            const responseEvento = await postData("/JudEventoAlta", payloadEvento);

            if (!responseEvento?.isSuccess) {
                const errorMsg = responseEvento?.detail || responseEvento?.error || "Error al registrar evento";
                setSnackbar({ open: true, msg: errorMsg, severity: "error" });
                setEventoDialog(prev => ({ ...prev, guardando: false }));
                return;
            }

            if (eventoDialog.agendarLlamada) {
                const payloadAgenda = {
                    idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
                    idCaso: eventoDialog.idJudCaso,
                    idSujeto: eventoDialog.idSujeto,
                    nombreSujeto: eventoDialog.nombreSujeto,
                    fecha: eventoDialog.fechaAgenda.format('YYYY-MM-DD'),
                    observaciones: eventoDialog.observacionesAgenda,
                    visto: 0,
                    tipo: "JUDICIAL"
                };

                const responseAgenda = await postData("/CasoAgendaRegistrar", payloadAgenda);

                if (!responseAgenda?.isSuccess) {
                    setSnackbar({ open: true, msg: responseAgenda?.error || "Evento guardado, pero error al registrar agenda", severity: "warning" });
                    setEventoDialog(prev => ({ ...prev, guardando: false }));
                    return;
                }

                setSnackbar({ open: true, msg: "Evento y agenda registrados correctamente", severity: "success" });
            } else {
                setSnackbar({ open: true, msg: "Evento registrado correctamente", severity: "success" });
            }

            handleCloseEvento();
            fetchData();
            cargarAlertas();
        } catch (ex) {
            console.error("Error registrando evento:", ex);
            const errorMsg = ex?.detail || ex?.response?.data?.detail || "Error al registrar evento";
            setSnackbar({ open: true, msg: errorMsg, severity: "error" });
        } finally {
            setEventoDialog(prev => ({ ...prev, guardando: false }));
        }
    };

    // Handlers para Dialog Agenda
    const handleOpenAgenda = (idJudCaso, nombreSujeto, idSujeto) => {
        setAgendaDialog({
            open: true,
            idJudCaso: idJudCaso,
            idSujeto: idSujeto || 0,
            nombreSujeto: nombreSujeto || "",
            fecha: dayjs(),
            observaciones: ""
        });
    };

    const handleCloseAgenda = () => {
        setAgendaDialog({
            open: false,
            idJudCaso: null,
            idSujeto: null,
            nombreSujeto: "",
            fecha: dayjs(),
            observaciones: ""
        });
    };

    const handleGuardarAgenda = async () => {
        if (!agendaDialog.fecha || !agendaDialog.observaciones.trim()) {
            setSnackbar({ open: true, msg: "Debe completar fecha y observaciones", severity: "warning" });
            return;
        }

        setGuardandoAgenda(true);
        try {
            const payload = {
                idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
                idCaso: agendaDialog.idJudCaso,
                idSujeto: agendaDialog.idSujeto,
                nombreSujeto: agendaDialog.nombreSujeto,
                fecha: agendaDialog.fecha.format('YYYY-MM-DD'),
                observaciones: agendaDialog.observaciones,
                visto: 0,
                tipo: "JUDICIAL"
            };

            const response = await postData("/CasoAgendaRegistrar", payload);

            if (response?.isSuccess) {
                setSnackbar({ open: true, msg: "Agenda registrada correctamente", severity: "success" });
                handleCloseAgenda();
                await cargarAgendasHoy();
            } else {
                setSnackbar({ open: true, msg: response?.error || "Error al registrar agenda", severity: "error" });
            }
        } catch (ex) {
            console.error("Error registrando agenda:", ex);
            setSnackbar({ open: true, msg: "Error al registrar agenda", severity: "error" });
        } finally {
            setGuardandoAgenda(false);
        }
    };

    const cargarAgendasHoy = async () => {
        try {
            const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;
            const hoy = dayjs().format('YYYY-MM-DD');

            const response = await postData("/CasoAgendaListar", {
                idUsuario: idUsuario,
                fechaDesde: hoy,
                fechaHasta: hoy,
                Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
            });

            const list = response?.value || [];
            const noVistas = list.filter(a => a.visto === 0 || a.visto === false).length;
            setAgendasNoVistas(noVistas);
        } catch (ex) {
            console.error("Error cargando agendas para notificaciones:", ex);
        }
    };

    const cargarAgendasConFiltros = async () => {
        setLoadingAgendas(true);
        try {
            const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;

            const response = await postData("/CasoAgendaListar", {
                idUsuario: idUsuario,
                fechaDesde: agendaFilters.fechaDesde.format('YYYY-MM-DD'),
                fechaHasta: agendaFilters.fechaHasta.format('YYYY-MM-DD'),
                Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
            });

            const list = response?.value || [];
            setAgendasHoy(list);
            aplicarFiltroNombre(list, agendaFilters.nombreSujeto);
        } catch (ex) {
            console.error("Error cargando agendas:", ex);
            setSnackbar({ open: true, msg: "Error al cargar las agendas", severity: "error" });
        } finally {
            setLoadingAgendas(false);
        }
    };

    const aplicarFiltroNombre = (agendas, nombreFiltro) => {
        if (!nombreFiltro || nombreFiltro.trim() === "") {
            setAgendasFiltradas(agendas);
        } else {
            const filtradas = agendas.filter(a =>
                a.nombreSujeto?.toLowerCase().includes(nombreFiltro.toLowerCase())
            );
            setAgendasFiltradas(filtradas);
        }
    };

    const handleMarcarVisto = async (idAgenda) => {
        try {
            const response = await postData(`/CasoAgendaMarcarVisto/${idAgenda}`, {});

            if (response?.isSuccess) {
                await cargarAgendasConFiltros();
                await cargarAgendasHoy();
            }
        } catch (ex) {
            console.error("Error marcando agenda como vista:", ex);
        }
    };

    const handleOpenNotificaciones = async () => {
        const newFilters = {
            fechaDesde: dayjs(),
            fechaHasta: dayjs(),
            nombreSujeto: ""
        };
        setAgendaFilters(newFilters);
        setNotificacionesDialog(true);

        setLoadingAgendas(true);
        try {
            const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;

            const response = await postData("/CasoAgendaListar", {
                idUsuario: idUsuario,
                fechaDesde: newFilters.fechaDesde.format('YYYY-MM-DD'),
                fechaHasta: newFilters.fechaHasta.format('YYYY-MM-DD'),
                Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
            });

            const list = response?.value || [];
            setAgendasHoy(list);
            setAgendasFiltradas(list);
        } catch (ex) {
            console.error("Error cargando agendas:", ex);
            setSnackbar({ open: true, msg: "Error al cargar las agendas", severity: "error" });
        } finally {
            setLoadingAgendas(false);
        }
    };

    const handleCloseNotificaciones = () => {
        setNotificacionesDialog(false);
        setAgendasHoy([]);
        setAgendasFiltradas([]);
    };

    const handleAgendaFilterChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...agendaFilters, [name]: value };
        setAgendaFilters(newFilters);

        if (name === "nombreSujeto") {
            aplicarFiltroNombre(agendasHoy, value);
        }
    };

    const handleBuscarAgendas = async () => {
        await cargarAgendasConFiltros();
    };

    // Handlers para Contactos Dialog
    const handleOpenContactos = async (item) => {
        const contactos = item.sujetoContactos || [];
        // Ordenar: primero los que tienen prioridad (orden >= 0), luego los que no tienen (orden < 0)
        const sortedContactos = [...contactos].sort((a, b) => {
            const ordenA = a.orden ?? -1;
            const ordenB = b.orden ?? -1;

            // Si ambos tienen orden válido (>= 0), ordenar ascendente
            if (ordenA >= 0 && ordenB >= 0) return ordenA - ordenB;
            // Si solo A tiene orden válido, A va primero
            if (ordenA >= 0 && ordenB < 0) return -1;
            // Si solo B tiene orden válido, B va primero
            if (ordenA < 0 && ordenB >= 0) return 1;
            // Si ninguno tiene orden válido, mantener orden original
            return 0;
        });

        setContactosDialog({
            open: true,
            idSujeto: item.idSujeto || null,
            nombreSujeto: item.nombreSujeto || "",
            contactos: sortedContactos
        });
    };

    const handleCloseContactos = () => {
        setContactosDialog({
            open: false,
            idSujeto: null,
            nombreSujeto: "",
            contactos: []
        });
    };

    // Handlers para Edit Contacto
    const handleOpenEditContacto = async (contacto, idSujeto) => {
        try {
            const preTipo = tiposContacto.find(x => x.id === contacto.idSujetoContactoTipo) || null;
            const preOrigen = origenesContacto.find(x => x.id === contacto.idSujetoContactoOrigen) || null;
            const prePrioridad = prioridadesContacto.find(x => x.id === contacto.idSujetoPrioridadContacto) || null;

            setEditContactoDialog({
                open: true,
                contacto: contacto,
                idSujeto: idSujeto,
                valorContacto: contacto.contacto || "",
                selectedTipo: preTipo,
                selectedOrigen: preOrigen,
                selectedPrioridad: prePrioridad,
                saving: false
            });
        } catch (ex) {
            console.error('Error abriendo editar contacto', ex);
        }
    };

    const handleCloseEditContacto = () => {
        setEditContactoDialog({
            open: false,
            contacto: null,
            idSujeto: null,
            valorContacto: "",
            selectedTipo: null,
            selectedOrigen: null,
            selectedPrioridad: null,
            saving: false
        });
    };

    const handleSaveEditContacto = async () => {
        const { contacto, idSujeto, valorContacto, selectedTipo, selectedOrigen, selectedPrioridad } = editContactoDialog;

        if (!valorContacto || !selectedTipo || !selectedOrigen) {
            setSnackbar({ open: true, msg: 'Complete los campos requeridos', severity: 'warning' });
            return;
        }

        setEditContactoDialog(prev => ({ ...prev, saving: true }));

        try {
            const payload = {
                idSujetoContacto: contacto.idSujetoContacto,
                idSujeto: idSujeto,
                idSujetoContactoTipo: selectedTipo.id,
                idSujetoContactoOrigen: selectedOrigen.id,
                idSujetoPrioridadContacto: selectedPrioridad?.id || 0,
                contacto: valorContacto
            };

            const res = await pathData('/SujetoContactoUpdate', payload);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Contacto actualizado correctamente', severity: 'success' });

                // Actualizar el contacto en el dialog
                const updatedContactos = contactosDialog.contactos.map(c =>
                    c.idSujetoContacto === contacto.idSujetoContacto
                        ? {
                            ...c,
                            contacto: valorContacto,
                            tipoContacto: selectedTipo.label,
                            origen: selectedOrigen.label,
                            prioridadNombre: selectedPrioridad?.label || "",
                            idSujetoContactoTipo: selectedTipo.id,
                            idSujetoContactoOrigen: selectedOrigen.id,
                            idSujetoPrioridadContacto: selectedPrioridad?.id || 0,
                            orden: selectedPrioridad?.orden
                        }
                        : c
                );

                // Ordenar: primero los que tienen prioridad (orden >= 0), luego los que no tienen (orden < 0)
                const sortedContactos = [...updatedContactos].sort((a, b) => {
                    const ordenA = a.orden ?? -1;
                    const ordenB = b.orden ?? -1;

                    // Si ambos tienen orden válido (>= 0), ordenar ascendente
                    if (ordenA >= 0 && ordenB >= 0) return ordenA - ordenB;
                    // Si solo A tiene orden válido, A va primero
                    if (ordenA >= 0 && ordenB < 0) return -1;
                    // Si solo B tiene orden válido, B va primero
                    if (ordenA < 0 && ordenB >= 0) return 1;
                    // Si ninguno tiene orden válido, mantener orden original
                    return 0;
                });

                setContactosDialog(prev => ({ ...prev, contactos: sortedContactos }));

                // Actualizar en la grilla y en list
                setRows(prevRows => prevRows.map(row => {
                    const item = list.find(i => i.idSujeto === idSujeto);
                    if (item && item.idSujeto === idSujeto) {
                        item.sujetoContactos = item.sujetoContactos.map(c =>
                            c.idSujetoContacto === contacto.idSujetoContacto
                                ? {
                                    ...c,
                                    contacto: valorContacto,
                                    tipoContacto: selectedTipo.label,
                                    origen: selectedOrigen.label,
                                    prioridadNombre: selectedPrioridad?.label || "",
                                    idSujetoContactoTipo: selectedTipo.id,
                                    idSujetoContactoOrigen: selectedOrigen.id,
                                    idSujetoPrioridadContacto: selectedPrioridad?.id || 0
                                }
                                : c
                        );
                    }
                    return row;
                }));

                handleCloseEditContacto();
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error actualizando contacto', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error guardando contacto', ex);
            setSnackbar({ open: true, msg: 'Error guardando contacto', severity: 'error' });
        } finally {
            setEditContactoDialog(prev => ({ ...prev, saving: false }));
        }
    };

    // Handlers para Add Contacto
    const handleOpenAddContacto = (idSujeto) => {
        setAddContactoDialog({
            open: true,
            idSujeto: idSujeto,
            valorContacto: "",
            selectedTipo: null,
            selectedOrigen: null,
            selectedPrioridad: null,
            saving: false
        });
    };

    const handleCloseAddContacto = () => {
        setAddContactoDialog({
            open: false,
            idSujeto: null,
            valorContacto: "",
            selectedTipo: null,
            selectedOrigen: null,
            selectedPrioridad: null,
            saving: false
        });
    };

    const handleSaveAddContacto = async () => {
        const { idSujeto, valorContacto, selectedTipo, selectedOrigen, selectedPrioridad } = addContactoDialog;

        if (!valorContacto || !selectedTipo || !selectedOrigen) {
            setSnackbar({ open: true, msg: 'Complete los campos requeridos', severity: 'warning' });
            return;
        }

        setAddContactoDialog(prev => ({ ...prev, saving: true }));

        try {
            const payload = {
                idSujeto: idSujeto,
                idSujetoContactoTipo: selectedTipo.id,
                idSujetoContactoOrigen: selectedOrigen.id,
                idSujetoPrioridadContacto: selectedPrioridad?.id || 0,
                contacto: valorContacto
            };

            const res = await postData('/SujetoContactoAlta', payload);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Contacto creado correctamente', severity: 'success' });

                // Agregar el nuevo contacto al dialog
                const nuevoContacto = {
                    idSujetoContacto: res.value?.idSujetoContacto || 0,
                    contacto: valorContacto,
                    tipoContacto: selectedTipo.label,
                    origen: selectedOrigen.label,
                    prioridadNombre: selectedPrioridad?.label || "",
                    idSujetoContactoTipo: selectedTipo.id,
                    idSujetoContactoOrigen: selectedOrigen.id,
                    idSujetoPrioridadContacto: selectedPrioridad?.id || 0,
                    orden: selectedPrioridad?.orden ?? -1
                };

                // Agregar y ordenar la lista
                const updatedContactos = [...contactosDialog.contactos, nuevoContacto];
                const sortedContactos = [...updatedContactos].sort((a, b) => {
                    const ordenA = a.orden;
                    const ordenB = b.orden;

                    // Si ambos tienen orden válido (no -1), ordenar ascendente
                    if (ordenA >= 0 && ordenB >= 0) return ordenA - ordenB;
                    // Si solo A tiene orden válido, A va primero
                    if (ordenA >= 0 && ordenB < 0) return -1;
                    // Si solo B tiene orden válido, B va primero
                    if (ordenA < 0 && ordenB >= 0) return 1;
                    // Si ninguno tiene orden válido, mantener orden original
                    return 0;
                });

                setContactosDialog(prev => ({
                    ...prev,
                    contactos: sortedContactos
                }));

                handleCloseAddContacto();
                // Recargar datos para actualizar la grilla
                fetchData();
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error creando contacto', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error guardando contacto', ex);
            setSnackbar({ open: true, msg: 'Error guardando contacto', severity: 'error' });
        } finally {
            setAddContactoDialog(prev => ({ ...prev, saving: false }));
        }
    };

    // Función auxiliar para actualizar solo un caso específico
    const actualizarCasoEspecifico = async (idJudCaso) => {
        try {
            const response = await postData(`/JudCasoListar?idJudCaso=${idJudCaso}`, {});
            if (response?.isSuccess && response?.value?.length > 0) {
                const casoActualizado = response.value[0];
                
                // Solo actualizar list, el useEffect regenerará rows automáticamente
                setList(prevList => 
                    prevList.map(item => 
                        item.idJudCaso === idJudCaso ? casoActualizado : item
                    )
                );
            }
        } catch (error) {
            console.error('Error actualizando caso específico:', error);
        }
    };

    // Función auxiliar para generar una fila de la tabla
    const generarFilaTabla = (item) => {
        const caso = (
            <MDBox>
                <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                    <MDTypography variant="h6" color="text" fontWeight="medium">
                        Caso #{item.idJudCaso}
                    </MDTypography>
                </MDBox>

                <MDBox ml={4}>
                    <MDTypography variant="caption" color="info" fontWeight="bold" display="block">
                        Organismo: {item.organismo}
                    </MDTypography>

                    <MDBox mt={0.5}>
                        <MDBox display="flex" alignItems="center" gap={1}>
                            <MDTypography variant="caption" color="text" fontWeight="medium">
                                {item.nombreSujeto}
                            </MDTypography>

                            {/* Mostrar icono de contactos con badge si tiene contactos, sino mostrar botón agregar */}
                            {item.sujetoContactos && item.sujetoContactos.length > 0 ? (
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={0.5}
                                    sx={{
                                        cursor: 'pointer',
                                        padding: '4px 8px',
                                        borderRadius: 1,
                                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(25, 118, 210, 0.2)',
                                        }
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenContactos(item);
                                    }}
                                >
                                    <Phone sx={{ fontSize: 16, color: 'info.main' }} />
                                    <Badge
                                        badgeContent={item.sujetoContactos.length}
                                        color="primary"
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                position: 'relative',
                                                transform: 'none',
                                                fontSize: '0.65rem',
                                                height: '16px',
                                                minWidth: '16px',
                                                fontWeight: 'bold'
                                            }
                                        }}
                                    >
                                        <span />
                                    </Badge>
                                </MDBox>
                            ) : (
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={0.3}
                                    sx={{
                                        cursor: 'pointer',
                                        padding: '2px 6px',
                                        borderRadius: 1,
                                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(76, 175, 80, 0.2)',
                                        }
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenAddContacto(item.idSujeto);
                                    }}
                                    title="Agregar contacto"
                                >
                                    <Phone sx={{ fontSize: 16, color: 'success.main' }} />
                                    <Add sx={{ fontSize: 12, color: 'success.main' }} />
                                </MDBox>
                            )}

                            <WhatsAppCaso item={item} />
                        </MDBox>

                        <MDTypography variant="caption" color="secondary" fontSize="0.7rem" display="block">
                            {item.tipoIdentificacion}: {item.identificacion}
                        </MDTypography>

                    </MDBox>

                    <MDTypography variant="caption" color="success" fontWeight="bold" display="block" mt={0.5}>
                        Monto: ${item.monto?.toLocaleString() || 0}
                    </MDTypography>
                    <MDTypography
                        variant="caption"
                        color="text"
                        fontWeight="medium"
                        display="block"
                        mt={0.5}
                        onClick={() => item.objetos && item.objetos.length > 30 && handleOpenObjetosDialog(item.objetos)}
                        sx={{
                            cursor: item.objetos && item.objetos.length > 30 ? 'pointer' : 'default',
                            '&:hover': item.objetos && item.objetos.length > 30 ? { color: 'info.main', textDecoration: 'underline' } : {}
                        }}
                    >
                        Objetos ({item.cantidadObjetos}): {item.objetos && item.objetos.length > 30 ? `${item.objetos.substring(0, 30)}...` : item.objetos}
                    </MDTypography>
                </MDBox>
            </MDBox>
        );

        const gestor = (
            <MDBox display="flex" alignItems="center" gap={0.5}>
                <MDTypography variant="caption" color="text" fontWeight="medium" fontSize="0.6rem">
                    {item.usuario}
                </MDTypography>
                {(item.idUsuario === idUsuarioLogueado || perfilActual.puedeReasignarCasos) && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenCambiarGestor(item);
                        }}
                        sx={{ padding: 0, color: 'info.main' }}
                        title="Cambiar gestor"
                    >
                        <SwapHoriz sx={{ fontSize: 16 }} />
                    </IconButton>
                )}
            </MDBox>
        );

        const estados = (
            <MDBox>
                {item.estadoCasos && item.estadoCasos.length > 0 ? (
                    item.estadoCasos.map((estado, idx) => (
                        <MDBox key={idx} mb={0.5}>
                            <MDTypography variant="caption" fontSize="0.7rem">
                                <MDTypography component="span" variant="caption" color="success" fontWeight="medium" fontSize="0.7rem">
                                    {estado.subEstado}
                                </MDTypography>
                                {' - '}
                                <MDTypography component="span" variant="caption" color="text" fontSize="0.65rem">
                                    {estado.estado}
                                </MDTypography>
                            </MDTypography>
                        </MDBox>
                    ))
                ) : (
                    <MDTypography variant="caption" color="error">
                        Sin estados
                    </MDTypography>
                )}
            </MDBox>
        );

        const expediente = (
            <MDBox>
                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.3}>
                    <MDTypography component="span" variant="caption" color="info" fontWeight="bold" fontSize="0.7rem">
                        Expediente Judicial:
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={0.5}>
                        <MDTypography variant="caption" color="text" fontSize="0.7rem">
                            {item.expedienteJudicial || 'NO'}
                        </MDTypography>
                        <IconButton
                            size="small"
                            onClick={() => handleOpenEditExpediente(item.idJudCaso, "expedienteJudicial", "Expediente Judicial", item.expedienteJudicial, "string")}
                            sx={{ padding: 0, minWidth: 0, color: 'info.main', '&:hover': { color: 'info.dark' } }}
                        >
                            <EditIcon sx={{ fontSize: 12 }} />
                        </IconButton>
                    </MDBox>
                </MDBox>

                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.3}>
                    <MDTypography component="span" variant="caption" color="info" fontWeight="bold" fontSize="0.7rem">
                        Cert Judicial:
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={0.5}>
                        <MDTypography variant="caption" color="text" fontSize="0.7rem">
                            {item.certificadoJudicial || 'NO'}
                        </MDTypography>
                        <IconButton
                            size="small"
                            onClick={() => handleOpenEditExpediente(item.idJudCaso, "certificadoJudicial", "Certificado Judicial", item.certificadoJudicial, "string")}
                            sx={{ padding: 0, minWidth: 0, color: 'info.main', '&:hover': { color: 'info.dark' } }}
                        >
                            <EditIcon sx={{ fontSize: 12 }} />
                        </IconButton>
                    </MDBox>
                </MDBox>

                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.3}>
                    <MDTypography component="span" variant="caption" color="info" fontWeight="bold" fontSize="0.7rem">
                        Aporte Jubilatorio:
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1.5}>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color={item.aporteJubilatorioEstado === 1 ? "success" : "error"} fontWeight="bold" fontSize="0.7rem">
                                {item.aporteJubilatorioEstado === 1 ? 'SI' : 'NO'}
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleToggleEstado(item.idJudCaso, 'aporteJubilatorio', item.aporteJubilatorioEstado, item.aporteJubilatorio)}
                                sx={{ padding: 0, minWidth: 0, color: 'warning.main', '&:hover': { color: 'warning.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color="text" fontSize="0.7rem">
                                (${(item.aporteJubilatorio || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleOpenEditExpediente(item.idJudCaso, "aporteJubilatorio", "Aporte Jubilatorio", item.aporteJubilatorio, "decimal", item.aporteJubilatorioEstado)}
                                sx={{ padding: 0, minWidth: 0, color: 'info.main', '&:hover': { color: 'info.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                    </MDBox>
                </MDBox>

                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.3}>
                    <MDTypography component="span" variant="caption" color="info" fontWeight="bold" fontSize="0.7rem">
                        Tasa de Justicia:
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1.5}>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color={item.tasaDeJusticiaEstado === 1 ? "success" : "error"} fontWeight="bold" fontSize="0.7rem">
                                {item.tasaDeJusticiaEstado === 1 ? 'SI' : 'NO'}
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleToggleEstado(item.idJudCaso, 'tasaDeJusticia', item.tasaDeJusticiaEstado, item.tasaDeJusticia)}
                                sx={{ padding: 0, minWidth: 0, color: 'warning.main', '&:hover': { color: 'warning.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color="text" fontSize="0.7rem">
                                (${(item.tasaDeJusticia || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleOpenEditExpediente(item.idJudCaso, "tasaDeJusticia", "Tasa de Justicia", item.tasaDeJusticia, "decimal", item.tasaDeJusticiaEstado)}
                                sx={{ padding: 0, minWidth: 0, color: 'info.main', '&:hover': { color: 'info.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                    </MDBox>
                </MDBox>

                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.3}>
                    <MDTypography component="span" variant="caption" color="info" fontWeight="bold" fontSize="0.7rem">
                        Colegio de Abogados:
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1.5}>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color={item.colegioDeAbogadosEstado === 1 ? "success" : "error"} fontWeight="bold" fontSize="0.7rem">
                                {item.colegioDeAbogadosEstado === 1 ? 'SI' : 'NO'}
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleToggleEstado(item.idJudCaso, 'colegioDeAbogados', item.colegioDeAbogadosEstado, item.colegioDeAbogados)}
                                sx={{ padding: 0, minWidth: 0, color: 'warning.main', '&:hover': { color: 'warning.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" gap={0.5}>
                            <MDTypography variant="caption" color="text" fontSize="0.7rem">
                                (${(item.colegioDeAbogados || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                            </MDTypography>
                            <IconButton
                                size="small"
                                onClick={() => handleOpenEditExpediente(item.idJudCaso, "colegioDeAbogados", "Colegio de Abogados", item.colegioDeAbogados, "decimal", item.colegioDeAbogadosEstado)}
                                sx={{ padding: 0, minWidth: 0, color: 'info.main', '&:hover': { color: 'info.dark' } }}
                            >
                                <EditIcon sx={{ fontSize: 12 }} />
                            </IconButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </MDBox>
        );

        const fecha = (
            <MDTypography variant="caption" color="text">
                {item.fecha ? dayjs(item.fecha).format('DD/MM/YYYY') : '-'}
            </MDTypography>
        );

        const acciones = (
            <MDBox display="flex" flexDirection="column" gap={0.5}>
                <MDButton
                    variant="outlined"
                    color="warning"
                    size="small"
                    startIcon={<PersonCheck size={14} />}
                    fullWidth
                    onClick={() => handleAgregarEvento(item)}
                >
                    Agregar Evento
                </MDButton>
                <MDButton
                    variant="outlined"
                    color="success"
                    size="small"
                    startIcon={<ListTask size={14} />}
                    fullWidth
                    onClick={() => handleVerSeguimiento(item.idJudCaso)}
                >
                    Seguimiento
                </MDButton>
                <MDButton
                    variant="outlined"
                    color="info"
                    size="small"
                    startIcon={<CalendarEvent size={14} />}
                    fullWidth
                    onClick={() => handleOpenAgenda(item.idJudCaso, item.nombreSujeto, item.idSujeto)}
                >
                    Ver Agenda
                </MDButton>
            </MDBox>
        );

        return {
            caso,
            gestor,
            estados,
            expediente,
            fecha,
            acciones
        };
    };

    // Handlers para Delete Contacto
    const handleOpenDeleteContacto = (idSujetoContacto) => {
        setDeleteContactoDialog({
            open: true,
            idSujetoContacto: idSujetoContacto
        });
    };

    const handleCloseDeleteContacto = () => {
        setDeleteContactoDialog({
            open: false,
            idSujetoContacto: null
        });
    };

    const handleConfirmDeleteContacto = async () => {
        const { idSujetoContacto } = deleteContactoDialog;
        if (!idSujetoContacto) return;

        try {
            const res = await deleteData(`/SujetoContactoDelete/${idSujetoContacto}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Contacto eliminado correctamente', severity: 'success' });

                // Eliminar del dialog
                const updatedContactos = contactosDialog.contactos.filter(c =>
                    c.idSujetoContacto !== idSujetoContacto
                );
                setContactosDialog(prev => ({ ...prev, contactos: updatedContactos }));

                handleCloseDeleteContacto();
                // Recargar datos para actualizar la grilla
                fetchData();
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando contacto', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando contacto', ex);
            setSnackbar({ open: true, msg: 'Error eliminando contacto', severity: 'error' });
        }
    };

    // Handlers para Cambiar Gestor
    const handleOpenCambiarGestor = (item) => {
        setCambiarGestorDialog({
            open: true,
            idJudCaso: item.idJudCaso,
            idUsuarioActual: item.idUsuario,
            usuarioActual: item.usuario,
            selectedUsuario: null,
            guardando: false
        });
    };

    const handleCloseCambiarGestor = () => {
        setCambiarGestorDialog({
            open: false,
            idJudCaso: null,
            idUsuarioActual: null,
            usuarioActual: "",
            selectedUsuario: null,
            guardando: false
        });
    };

    const handleAceptarCambiarGestor = async () => {
        if (!cambiarGestorDialog.selectedUsuario) {
            setSnackbar({ open: true, msg: "Debe seleccionar un gestor", severity: "warning" });
            return;
        }

        // Validar que no sea el mismo usuario
        if (cambiarGestorDialog.selectedUsuario.id === cambiarGestorDialog.idUsuarioActual) {
            setSnackbar({ open: true, msg: "El gestor seleccionado ya está asignado a este caso", severity: "warning" });
            return;
        }

        setCambiarGestorDialog(prev => ({ ...prev, guardando: true }));

        try {
            const payload = {
                idCaso: cambiarGestorDialog.idJudCaso,
                idUsuario: cambiarGestorDialog.selectedUsuario.id,
                usuarioAnterior: cambiarGestorDialog.usuarioActual,
                usuarioNew: cambiarGestorDialog.selectedUsuario.label,
                IDUsuarioActual: parseInt(localStorage.getItem("iduserlogueado")) || 0
            };

            const response = await pathData("/UpdateGestorJudCaso", payload);

            if (response?.isSuccess) {
                setSnackbar({ open: true, msg: "Gestor actualizado correctamente", severity: "success" });
                handleCloseCambiarGestor();
                
                // Actualizar directamente el list con el nuevo gestor
                setList(prevList => 
                    prevList.map(item => {
                        if (item.idJudCaso === cambiarGestorDialog.idJudCaso) {
                            return {
                                ...item,
                                idUsuario: cambiarGestorDialog.selectedUsuario.id,
                                usuario: cambiarGestorDialog.selectedUsuario.label
                            };
                        }
                        return item;
                    })
                );
            } else {
                setSnackbar({ open: true, msg: response?.error || "Error al actualizar gestor", severity: "error" });
            }
        } catch (ex) {
            console.error("Error actualizando gestor:", ex);
            const errorMsg = ex?.message || "Error al actualizar gestor";
            setSnackbar({ open: true, msg: errorMsg, severity: "error" });
        } finally {
            setCambiarGestorDialog(prev => ({ ...prev, guardando: false }));
        }
    };

    // Handlers para edición de campos de expediente
    const handleOpenEditExpediente = (idJudCaso, fieldName, fieldLabel, fieldValue, fieldType, fieldEstado = 0) => {
        setEditExpedienteDialog({
            open: true,
            idJudCaso: idJudCaso,
            fieldName: fieldName,
            fieldLabel: fieldLabel,
            fieldValue: fieldValue || "",
            fieldType: fieldType,
            fieldEstado: fieldEstado || 0,
            saving: false
        });
    };

    const handleCloseEditExpediente = () => {
        setEditExpedienteDialog({
            open: false,
            idJudCaso: null,
            fieldName: "",
            fieldLabel: "",
            fieldValue: "",
            fieldType: "string",
            fieldEstado: 0,
            saving: false
        });
    };

    // Handler para toggle de estado SI/NO
    const handleToggleEstado = async (idJudCaso, fieldName, currentEstado, currentMonto) => {
        try {
            const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;
            const newEstado = currentEstado === 1 ? 0 : 1; // Toggle entre 0 y 1
            let endpoint = "";

            // Determinar el endpoint según el campo
            switch (fieldName) {
                case "aporteJubilatorio":
                    endpoint = `/JudCasoAporteJubilatorioUpdate?idjudCaso=${idJudCaso}&aporteJubilatorio=${currentMonto || 0}&aporteJubilatorioEstado=${newEstado}&idUsuario=${idUsuario}`;
                    break;
                case "tasaDeJusticia":
                    endpoint = `/JudCasoTasaDeJusticiaUpdate?idjudCaso=${idJudCaso}&tasaDeJusticia=${currentMonto || 0}&tasaDeJusticiaEstado=${newEstado}&idUsuario=${idUsuario}`;
                    break;
                case "colegioDeAbogados":
                    endpoint = `/JudCasoColegioDeAbogadosUpdate?idjudCaso=${idJudCaso}&colegioDeAbogados=${currentMonto || 0}&colegioDeAbogadosEstado=${newEstado}&idUsuario=${idUsuario}`;
                    break;
                default:
                    setSnackbar({ open: true, msg: "Campo no válido", severity: "error" });
                    return;
            }

            const response = await pathData(endpoint, {});

            if (response?.isSuccess) {
                setSnackbar({ open: true, msg: `Estado actualizado a ${newEstado === 1 ? 'SI' : 'NO'}`, severity: "success" });
                
                // Actualizar directamente el list con el nuevo estado
                setList(prevList => 
                    prevList.map(item => {
                        if (item.idJudCaso === idJudCaso) {
                            return {
                                ...item,
                                [`${fieldName}Estado`]: newEstado
                            };
                        }
                        return item;
                    })
                );
            } else {
                setSnackbar({ open: true, msg: response?.error || "Error al actualizar el estado", severity: "error" });
            }
        } catch (ex) {
            console.error("Error actualizando estado:", ex);
            setSnackbar({ open: true, msg: "Error al actualizar el estado", severity: "error" });
        }
    };

    const handleSaveEditExpediente = async () => {
        const { idJudCaso, fieldName, fieldValue, fieldType, fieldEstado } = editExpedienteDialog;

        if (!fieldValue || fieldValue.trim() === "") {
            setSnackbar({ open: true, msg: "El valor no puede estar vacío", severity: "warning" });
            return;
        }

        // Validar si es decimal
        if (fieldType === "decimal") {
            const numValue = parseFloat(fieldValue);
            if (isNaN(numValue)) {
                setSnackbar({ open: true, msg: "Debe ingresar un valor numérico válido", severity: "warning" });
                return;
            }
        }

        setEditExpedienteDialog(prev => ({ ...prev, saving: true }));

        try {
            const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;
            let endpoint = "";
            let paramValue = fieldValue;

            // Determinar el endpoint según el campo
            switch (fieldName) {
                case "expedienteJudicial":
                    endpoint = `/JudCasoExpedienteJudicialUpdate?idjudCaso=${idJudCaso}&expedienteJudicial=${encodeURIComponent(paramValue)}&idUsuario=${idUsuario}`;
                    break;
                case "certificadoJudicial":
                    endpoint = `/JudCasoCertificadoJudicialUpdate?idjudCaso=${idJudCaso}&certificadoJudicial=${encodeURIComponent(paramValue)}&idUsuario=${idUsuario}`;
                    break;
                case "aporteJubilatorio":
                    endpoint = `/JudCasoAporteJubilatorioUpdate?idjudCaso=${idJudCaso}&aporteJubilatorio=${paramValue}&aporteJubilatorioEstado=${fieldEstado}&idUsuario=${idUsuario}`;
                    break;
                case "tasaDeJusticia":
                    endpoint = `/JudCasoTasaDeJusticiaUpdate?idjudCaso=${idJudCaso}&tasaDeJusticia=${paramValue}&tasaDeJusticiaEstado=${fieldEstado}&idUsuario=${idUsuario}`;
                    break;
                case "colegioDeAbogados":
                    endpoint = `/JudCasoColegioDeAbogadosUpdate?idjudCaso=${idJudCaso}&colegioDeAbogados=${paramValue}&colegioDeAbogadosEstado=${fieldEstado}&idUsuario=${idUsuario}`;
                    break;
                default:
                    setSnackbar({ open: true, msg: "Campo no válido", severity: "error" });
                    setEditExpedienteDialog(prev => ({ ...prev, saving: false }));
                    return;
            }

            const response = await pathData(endpoint, {});

            if (response?.isSuccess) {
                setSnackbar({ open: true, msg: "Campo actualizado correctamente", severity: "success" });
                handleCloseEditExpediente();
                
                // Actualizar directamente el list con el nuevo valor
                setList(prevList => 
                    prevList.map(item => {
                        if (item.idJudCaso === idJudCaso) {
                            const updatedItem = { ...item };
                            
                            // Actualizar según el tipo de campo
                            if (fieldName === "expedienteJudicial" || fieldName === "certificadoJudicial") {
                                updatedItem[fieldName] = paramValue;
                            } else if (fieldName === "aporteJubilatorio" || fieldName === "tasaDeJusticia" || fieldName === "colegioDeAbogados") {
                                updatedItem[fieldName] = parseFloat(paramValue);
                                updatedItem[`${fieldName}Estado`] = fieldEstado;
                            }
                            
                            return updatedItem;
                        }
                        return item;
                    })
                );
            } else {
                setSnackbar({ open: true, msg: response?.error || "Error al actualizar el campo", severity: "error" });
            }
        } catch (ex) {
            console.error("Error actualizando campo:", ex);
            setSnackbar({ open: true, msg: "Error al actualizar el campo", severity: "error" });
        } finally {
            setEditExpedienteDialog(prev => ({ ...prev, saving: false }));
        }
    };

    // Función para exportar a Excel
    const handleExportarExcel = async () => {
        try {
            if (!list || list.length === 0) {
                setSnackbar({ open: true, msg: 'No hay datos para exportar', severity: 'warning' });
                return;
            }

            setLoadingExcel(true);
            setSnackbar({ open: true, msg: 'Obteniendo eventos de los casos...', severity: 'info' });

            // Preparar los datos para el Excel (ahora es async)
            const datosExportar = await Promise.all(list.map(async (item) => {
                // Separar estados por subEstado
                const estadoCasoGestion = item.estadoCasos?.find(ec => ec.subEstado === 'GESTION');
                const estadoCasoCautelar = item.estadoCasos?.find(ec => ec.subEstado === 'CAUTELAR');
                const estadoCasoProcesal = item.estadoCasos?.find(ec => ec.subEstado === 'PROCESAL');

                const estadoGestion = estadoCasoGestion?.estado || '';
                const estadoCautelar = estadoCasoCautelar?.estado || '';
                const estadoProcesal = estadoCasoProcesal?.estado || '';

                // Obtener eventos del caso mediante JudEventoListar
                let eventoProcesal = '';
                let eventoGestion = '';
                let eventoCautelar = '';
                let fechaEventoProcesal = '';
                let fechaEventoGestion = '';
                let fechaEventoCautelar = '';

                try {
                    const res = await getData(`/JudEventoListar?idJudCaso=${item.idJudCaso}`);
                    const eventos = res?.value || [];

                    // Filtrar y obtener el último evento de cada subEstado
                    const eventosProcesal = eventos.filter(e => e.subEstado === 'PROCESAL').sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
                    const eventosGestion = eventos.filter(e => e.subEstado === 'GESTION').sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
                    const eventosCautelar = eventos.filter(e => e.subEstado === 'CAUTELAR').sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

                    if (eventosProcesal.length > 0) {
                        eventoProcesal = eventosProcesal[0].tipoEvento || '';
                        fechaEventoProcesal = eventosProcesal[0].fecha ? dayjs(eventosProcesal[0].fecha).format('DD/MM/YYYY HH:mm') : '';
                    }

                    if (eventosGestion.length > 0) {
                        eventoGestion = eventosGestion[0].tipoEvento || '';
                        fechaEventoGestion = eventosGestion[0].fecha ? dayjs(eventosGestion[0].fecha).format('DD/MM/YYYY HH:mm') : '';
                    }

                    if (eventosCautelar.length > 0) {
                        eventoCautelar = eventosCautelar[0].tipoEvento || '';
                        fechaEventoCautelar = eventosCautelar[0].fecha ? dayjs(eventosCautelar[0].fecha).format('DD/MM/YYYY HH:mm') : '';
                    }
                } catch (error) {
                    console.error(`Error obteniendo eventos para caso ${item.idJudCaso}:`, error);
                }

                return {
                    'USUARIO ASIGNADO': item.usuario || '',
                    'ORGANISMO': item.organismo || '',
                    'N° de CASO': item.idJudCaso || '',
                    'FECHA DE NACIMIENTO DEL CASO': item.fecha ? dayjs(item.fecha).format('DD/MM/YYYY') : '',
                    'TIPO DE IDENTIFICACIÓN': item.tipoIdentificacion || '',
                    'IDENTIFICACIÓN': item.identificacion || '',
                    'NOMBRE DEL SUJETO': item.nombreSujeto || '',
                    'CANTIDAD DE OBJETOS INICIO': item.cantidadObjetos || 0,
                    'OBJETOS': item.objetos || '',
                    'MONTO INICIO': item.monto || 0,
                    'ÚLTIMO ESTADO PROCESAL': estadoProcesal,
                    'ÚLTIMO ESTADO DE GESTION': estadoGestion,
                    'ÚLTIMO ESTADO CAUTELAR': estadoCautelar,
                    'ÚLTIMO EVENTO PROCESAL': eventoProcesal,
                    'ÚLTIMO EVENTO DE GESTION': eventoGestion,
                    'ÚLTIMO EVENTO CAUTELAR': eventoCautelar,
                    'FECHA ÚLTIMO EVENTO PROCESAL': fechaEventoProcesal,
                    'FECHA ÚLTIMO EVENTO DE GESTION': fechaEventoGestion,
                    'FECHA ÚLTIMO EVENTO CAUTELAR': fechaEventoCautelar,
                    'EXPEDIENTE JUDICIAL': item.expedienteJudicial || '',
                    'CERTIFICADO JUDICIAL': item.certificadoJudicial || '',
                    'APORTE JUBILATORIO SI/NO': item.aporteJubilatorioEstado === 1 ? 'SI' : 'NO',
                    'APORTE JUBILATORIO MONTO': item.aporteJubilatorio || 0,
                    'TASA DE JUSTICIA SI/NO': item.tasaDeJusticiaEstado === 1 ? 'SI' : 'NO',
                    'TASA DE JUSTICIA MONTO': item.tasaDeJusticia || 0,
                    'COLEGIO DE ABOGADOS SI/NO': item.colegioDeAbogadosEstado === 1 ? 'SI' : 'NO',
                    'COLEGIO DE ABOGADOS MONTO': item.colegioDeAbogados || 0,
                    'CONTACTO': item.sujetoContactos?.map(c => c.contacto).join(', ') || ''
                };
            }));

            setSnackbar({ open: true, msg: 'Generando archivo Excel...', severity: 'info' });

            // Crear el libro y la hoja de trabajo
            const ws = XLSX.utils.json_to_sheet(datosExportar);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Casos Judiciales');

            // Ajustar ancho de columnas
            const colWidths = [
                { wch: 25 },  // USUARIO ASIGNADO
                { wch: 35 },  // ORGANISMO
                { wch: 12 },  // N° de CASO
                { wch: 25 },  // FECHA DE NACIMIENTO DEL CASO
                { wch: 20 },  // TIPO DE IDENTIFICACIÓN
                { wch: 18 },  // IDENTIFICACIÓN
                { wch: 35 },  // NOMBRE DEL SUJETO
                { wch: 25 },  // CANTIDAD DE OBJETOS INICIO
                { wch: 80 },  // OBJETOS
                { wch: 18 },  // MONTO INICIO
                { wch: 30 },  // ÚLTIMO ESTADO PROCESAL
                { wch: 30 },  // ÚLTIMO ESTADO DE GESTION
                { wch: 30 },  // ÚLTIMO ESTADO CAUTELAR
                { wch: 35 },  // ÚLTIMO EVENTO PROCESAL
                { wch: 35 },  // ÚLTIMO EVENTO DE GESTION
                { wch: 35 },  // ÚLTIMO EVENTO CAUTELAR
                { wch: 25 },  // FECHA ÚLTIMO EVENTO PROCESAL
                { wch: 25 },  // FECHA ÚLTIMO EVENTO DE GESTION
                { wch: 25 },  // FECHA ÚLTIMO EVENTO CAUTELAR
                { wch: 25 },  // EXPEDIENTE JUDICIAL
                { wch: 25 },  // CERTIFICADO JUDICIAL
                { wch: 25 },  // APORTE JUBILATORIO SI/NO
                { wch: 18 },  // MONTO (aporte)
                { wch: 25 },  // TASA DE JUSTICA SI/NO
                { wch: 18 },  // MONTO (tasa)
                { wch: 25 },  // COLEGIO DE ABOGADO SI/NO
                { wch: 18 },  // MONTO (colegio)
                { wch: 60 }   // CONTACTO
            ];
            ws['!cols'] = colWidths;

            // Aplicar estilos a la fila de encabezados (azul)
            const headerStyle = {
                fill: { fgColor: { rgb: "4472C4" } },
                font: { bold: true, color: { rgb: "FFFFFF" } },
                alignment: { horizontal: "center", vertical: "center" }
            };

            // Obtener el rango de la hoja
            const range = XLSX.utils.decode_range(ws['!ref']);
            
            // Aplicar estilo a cada celda del encabezado (primera fila)
            for (let col = range.s.c; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                if (!ws[cellAddress]) continue;
                ws[cellAddress].s = headerStyle;
            }

            // Generar el archivo
            const nombreArchivo = `Casos_Judiciales_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
            XLSX.writeFile(wb, nombreArchivo, { cellStyles: true });

            setSnackbar({ open: true, msg: 'Archivo Excel generado exitosamente', severity: 'success' });
        } catch (error) {
            setLoadingExcel(false);
            console.error('Error exportando a Excel:', error);
            setSnackbar({ open: true, msg: 'Error al generar el archivo Excel', severity: 'error' });
        } finally {
            setLoadingExcel(false);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Casos Judiciales
                                </MDTypography>
                                <MDBox display="flex" alignItems="center" gap={1}>
                                    <ManualAyuda seccion="Gestión Judicial" />
                                    {/* Iconos de Alertas */}
                                    <Tooltip title="Alertas vencidas (fuera de plazo)" placement="bottom">
                                        <MuiIconButton
                                            onClick={() => handleOpenAlertDialog('rojo')}
                                            sx={{ color: 'white' }}
                                        >
                                            <Badge
                                                badgeContent={alertasRojas.length}
                                                color="error"
                                                sx={{
                                                    '& .MuiBadge-badge': {
                                                        fontWeight: alertasRojas.length > 0 ? 'bold' : 'normal'
                                                    }
                                                }}
                                            >
                                                <AccessAlarm sx={{ fontSize: 28, color: '#f44336' }} />
                                            </Badge>
                                        </MuiIconButton>
                                    </Tooltip>

                                    <Tooltip title="Vence hoy o mañana (1 día o menos)" placement="bottom">
                                        <MuiIconButton
                                            onClick={() => handleOpenAlertDialog('amarillo')}
                                            sx={{ color: 'white' }}
                                        >
                                            <Badge
                                                badgeContent={alertasAmarillas.length}
                                                sx={{
                                                    '& .MuiBadge-badge': {
                                                        backgroundColor: '#ff9800',
                                                        color: 'white',
                                                        fontWeight: alertasAmarillas.length > 0 ? 'bold' : 'normal'
                                                    }
                                                }}
                                            >
                                                <Schedule sx={{ fontSize: 28, color: '#ff9800' }} />
                                            </Badge>
                                        </MuiIconButton>
                                    </Tooltip>

                                    <Tooltip title="En plazo (más de 2 días para vencer)" placement="bottom">
                                        <MuiIconButton
                                            onClick={() => handleOpenAlertDialog('verde')}
                                            sx={{ color: 'white' }}
                                        >
                                            <Badge
                                                badgeContent={alertasVerdes.length}
                                                color="success"
                                                sx={{
                                                    '& .MuiBadge-badge': {
                                                        fontWeight: alertasVerdes.length > 0 ? 'bold' : 'normal'
                                                    }
                                                }}
                                            >
                                                <EventAvailable sx={{ fontSize: 28, color: '#90ee90' }} />
                                            </Badge>
                                        </MuiIconButton>
                                    </Tooltip>

                                    <MuiIconButton
                                        onClick={handleOpenNotificaciones}
                                        sx={{ color: 'white' }}
                                    >
                                        <Badge
                                            badgeContent={agendasNoVistas}
                                            color="error"
                                            sx={{
                                                '& .MuiBadge-badge': {
                                                    fontWeight: agendasNoVistas > 0 ? 'bold' : 'normal'
                                                }
                                            }}
                                        >
                                            <Notifications sx={{ fontSize: 28 }} />
                                        </Badge>
                                    </MuiIconButton>
                                </MDBox>
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                {/* Primera fila de filtros */}
                                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                                    <MDInput
                                        label="Nombre Sujeto"
                                        value={filtroNombreSujeto}
                                        onChange={(e) => setFiltroNombreSujeto(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Identificación"
                                        value={filtroIdentificacion}
                                        onChange={(e) => setFiltroIdentificacion(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        name="objetos"
                                        label="Objetos"
                                        value={filtroObjetos}
                                        onChange={(e) => setFiltroObjetos(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <Autocomplete
                                        options={organismos}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={filtroOrganismo}
                                        onChange={(e, newValue) => setFiltroOrganismo(newValue)}
                                        renderInput={(params) => <TextField {...params} label="Organismo" />}
                                        sx={{ width: 400 }}
                                    />
                                    <Autocomplete
                                        options={usuarios}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={filtroUsuario}
                                        onChange={(e, newValue) => setFiltroUsuario(newValue)}
                                        renderInput={(params) => <TextField {...params} label="Gestor" />}
                                        sx={{ width: 200 }}
                                    />
                                    <Autocomplete
                                        options={[
                                            { id: 0, label: "Todos" },
                                            { id: 1, label: "Si" },
                                            { id: 2, label: "No" }
                                        ]}
                                        value={filtroPoseeContactos}
                                        onChange={(e, newValue) => setFiltroPoseeContactos(newValue || { id: 0, label: "Todos" })}
                                        renderInput={(params) => <TextField {...params} label="Posee Contactos" />}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: 200 }}
                                    />
                                    <Autocomplete
                                        options={[
                                            { id: 0, label: "Todos" },
                                            { id: 1, label: "Si" },
                                            { id: 2, label: "No" }
                                        ]}
                                        value={filtroPoseeCuit}
                                        onChange={(e, newValue) => setFiltroPoseeCuit(newValue || { id: 0, label: "Todos" })}
                                        renderInput={(params) => <TextField {...params} label="Posee CUIT" />}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: 200 }}
                                    />
                                </MDBox>
                                {/* Segunda fila de filtros */}
                                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                                    <Autocomplete
                                        options={subEstados}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={filtroSubEstado}
                                        onChange={(e, newValue) => {
                                            setFiltroSubEstado(newValue);
                                            setFiltroEstado(null);
                                        }}
                                        disableClearable={false}
                                        freeSolo={false}
                                        renderInput={(params) => <TextField {...params} label="Sub Estado" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                        sx={{ width: 200 }}
                                    />
                                    <Autocomplete
                                        options={filtroSubEstado ? estados.filter(e => e.subEstado === filtroSubEstado.label) : []}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={filtroEstado}
                                        onChange={(e, newValue) => setFiltroEstado(newValue)}
                                        disableClearable={false}
                                        freeSolo={false}
                                        disabled={!filtroSubEstado}
                                        renderInput={(params) => <TextField {...params} label="Estado" inputProps={{ ...params.inputProps, readOnly: true }} />}
                                        sx={{ width: 200 }}
                                    />
                                    <MDInput
                                        label="Numero de Caso"
                                        type="number"
                                        value={filtroIdJudCaso}
                                        onChange={(e) => setFiltroIdJudCaso(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Nro Expediente"
                                        type="text"
                                        value={filtroNroExpediente}
                                        onChange={(e) => setFiltroNroExpediente(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Cant. Objetos Desde"
                                        type="number"
                                        value={filtroCantObjetosDesde}
                                        onChange={(e) => setFiltroCantObjetosDesde(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Cant. Objetos Hasta"
                                        type="number"
                                        value={filtroCantObjetosHasta}
                                        onChange={(e) => setFiltroCantObjetosHasta(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Monto Desde ($)"
                                        type="number"
                                        value={filtroMontoDesde}
                                        onChange={(e) => setFiltroMontoDesde(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                    <MDInput
                                        label="Monto Hasta ($)"
                                        type="number"
                                        value={filtroMontoHasta}
                                        onChange={(e) => setFiltroMontoHasta(e.target.value)}
                                        sx={{ width: 200, height: 50 }}
                                    />
                                </MDBox>
                                {/* Tercera fila de filtros */}
                                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DatePicker
                                            label="Fecha Desde"
                                            value={filtroFechaDesde}
                                            onChange={(newValue) => setFiltroFechaDesde(newValue)}
                                            slotProps={{ textField: { sx: { width: 200 } } }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DatePicker
                                            label="Fecha Hasta"
                                            value={filtroFechaHasta}
                                            onChange={(newValue) => setFiltroFechaHasta(newValue)}
                                            slotProps={{ textField: { sx: { width: 200 } } }}
                                        />
                                    </LocalizationProvider>
                                </MDBox>

                                {/* Botones de acción */}
                                <MDBox mt={2} display="flex" gap={2}>
                                    <MDButton
                                        onClick={handleBuscar}
                                        variant="gradient"
                                        color="info"
                                        startIcon={<SearchIcon />}
                                    >
                                        Buscar
                                    </MDButton>
                                    <MDButton
                                        onClick={handleLimpiar}
                                        variant="gradient"
                                        color="error"
                                    >
                                        Limpiar
                                    </MDButton>
                                    <MDButton
                                        onClick={handleExportarExcel}
                                        variant="gradient"
                                        color="success"
                                        startIcon={loadingExcel ? <CircularProgress size={20} color="inherit" /> : <FileDownload />}
                                        disabled={!list || list.length === 0 || loadingExcel}
                                    >
                                        {loadingExcel ? 'Procesando...' : 'Excel'}
                                    </MDButton>
                                </MDBox>

                                {/* Tabla */}
                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        name={"casos_judiciales_table"}    
                                        key={refreshKey}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'info', variant: 'gradient' }}
                                    />
                                )}

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>

                                {/* Dialog Ver Contactos */}
                                <Dialog
                                    open={contactosDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseContactos(); }}
                                    maxWidth="md"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-contactos-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Contactos de {contactosDialog.nombreSujeto}
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={1.5}>
                                            {contactosDialog.contactos.length > 0 ? (
                                                contactosDialog.contactos.map((contacto) => (
                                                    <MDBox
                                                        key={contacto.idSujetoContacto}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        p={1.5}
                                                        sx={{
                                                            backgroundColor: 'rgba(0,0,0,0.02)',
                                                            borderRadius: 1,
                                                            border: '1px solid rgba(0,0,0,0.08)'
                                                        }}
                                                    >
                                                        <MDBox display="flex" alignItems="center" gap={1} flex={1}>
                                                            {contacto.tipoContacto?.toLowerCase().includes('mail') || contacto.tipoContacto?.toLowerCase().includes('email') ? (
                                                                <Email sx={{ fontSize: 20, color: 'primary.main' }} />
                                                            ) : (
                                                                <Phone sx={{ fontSize: 20, color: 'info.main' }} />
                                                            )}
                                                            <MDBox>
                                                                <MDTypography variant="body2" fontWeight="medium">
                                                                    <span style={{ color: 'inherit' }}>{contacto.tipoContacto}</span>
                                                                    {contacto.prioridadNombre && (
                                                                        <span style={{
                                                                            color: contacto.prioridadNombre?.toLowerCase() === 'prioritario' ? '#1976d2' : '#d32f2f',
                                                                            fontWeight: 600
                                                                        }}>
                                                                            {` - ${contacto.prioridadNombre}`}
                                                                        </span>
                                                                    )}
                                                                </MDTypography>
                                                                <MDTypography variant="caption" color="text">
                                                                    {contacto.contacto}
                                                                </MDTypography>
                                                                {contacto.origen && (
                                                                    <MDTypography variant="caption" color="secondary" display="block">
                                                                        Origen: {contacto.origen}
                                                                    </MDTypography>
                                                                )}
                                                            </MDBox>
                                                        </MDBox>
                                                        <MDBox display="flex" gap={0.5}>
                                                            <MuiIconButton
                                                                size="small"
                                                                onClick={() => handleOpenEditContacto(contacto, contactosDialog.idSujeto)}
                                                                sx={{ padding: '6px' }}
                                                            >
                                                                <EditIcon color="info" fontSize="small" />
                                                            </MuiIconButton>
                                                            <MuiIconButton
                                                                size="small"
                                                                onClick={() => handleOpenDeleteContacto(contacto.idSujetoContacto)}
                                                                sx={{ padding: '6px' }}
                                                            >
                                                                <CloseIcon color="error" fontSize="small" />
                                                            </MuiIconButton>
                                                        </MDBox>
                                                    </MDBox>
                                                ))
                                            ) : (
                                                <MDTypography variant="body2" color="text" textAlign="center" p={2}>
                                                    No hay contactos registrados
                                                </MDTypography>
                                            )}
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="success" onClick={() => handleOpenAddContacto(contactosDialog.idSujeto)} startIcon={<Add />}>
                                            Agregar
                                        </MDButton>
                                        <MDButton variant="contained" color="info" onClick={handleCloseContactos}>
                                            Cerrar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Editar Contacto */}
                                <Dialog
                                    open={editContactoDialog.open}
                                    onClose={handleCloseEditContacto}
                                    maxWidth="sm"
                                    fullWidth
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="draggable-edit-contacto-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="draggable-edit-contacto-title">
                                        Editar Contacto
                                        <IconButton
                                            onClick={handleCloseEditContacto}
                                            sx={{ position: 'absolute', right: 8, top: 8 }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Contacto *"
                                                    value={editContactoDialog.valorContacto}
                                                    onChange={(e) => setEditContactoDialog(prev => ({
                                                        ...prev,
                                                        valorContacto: e.target.value
                                                    }))}
                                                    size="small"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={tiposContacto}
                                                    value={editContactoDialog.selectedTipo}
                                                    onChange={(e, val) => setEditContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedTipo: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Tipo *" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={origenesContacto}
                                                    value={editContactoDialog.selectedOrigen}
                                                    onChange={(e, val) => setEditContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedOrigen: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Origen *" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={prioridadesContacto}
                                                    value={editContactoDialog.selectedPrioridad}
                                                    onChange={(e, val) => setEditContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedPrioridad: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Prioridad" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton onClick={handleCloseEditContacto} color="secondary">
                                            Cancelar
                                        </MDButton>
                                        <MDButton
                                            onClick={handleSaveEditContacto}
                                            variant="gradient"
                                            color="info"
                                            disabled={editContactoDialog.saving}
                                        >
                                            {editContactoDialog.saving ? 'Guardando...' : 'Guardar'}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Agregar Contacto */}
                                <Dialog
                                    open={addContactoDialog.open}
                                    onClose={handleCloseAddContacto}
                                    maxWidth="sm"
                                    fullWidth
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="draggable-add-contacto-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="draggable-add-contacto-title">
                                        Agregar Contacto
                                        <IconButton
                                            onClick={handleCloseAddContacto}
                                            sx={{ position: 'absolute', right: 8, top: 8 }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Contacto *"
                                                    value={addContactoDialog.valorContacto}
                                                    onChange={(e) => setAddContactoDialog(prev => ({
                                                        ...prev,
                                                        valorContacto: e.target.value
                                                    }))}
                                                    size="small"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={tiposContacto}
                                                    value={addContactoDialog.selectedTipo}
                                                    onChange={(e, val) => setAddContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedTipo: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Tipo *" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={origenesContacto}
                                                    value={addContactoDialog.selectedOrigen}
                                                    onChange={(e, val) => setAddContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedOrigen: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Origen *" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={prioridadesContacto}
                                                    value={addContactoDialog.selectedPrioridad}
                                                    onChange={(e, val) => setAddContactoDialog(prev => ({
                                                        ...prev,
                                                        selectedPrioridad: val
                                                    }))}
                                                    renderInput={(params) => <TextField {...params} label="Prioridad" size="small" />}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                />
                                            </Grid>
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton onClick={handleCloseAddContacto} color="secondary">
                                            Cancelar
                                        </MDButton>
                                        <MDButton
                                            onClick={handleSaveAddContacto}
                                            variant="gradient"
                                            color="success"
                                            disabled={addContactoDialog.saving}
                                        >
                                            {addContactoDialog.saving ? 'Guardando...' : 'Agregar'}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Eliminar Contacto */}
                                <Dialog
                                    open={deleteContactoDialog.open}
                                    onClose={handleCloseDeleteContacto}
                                    maxWidth="xs"
                                    fullWidth
                                >
                                    <DialogTitle>
                                        Confirmar Eliminación
                                        <IconButton
                                            onClick={handleCloseDeleteContacto}
                                            sx={{ position: 'absolute', right: 8, top: 8 }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDTypography variant="body2">
                                            ¿Está seguro que desea eliminar este contacto?
                                        </MDTypography>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton onClick={handleCloseDeleteContacto} color="secondary">
                                            Cancelar
                                        </MDButton>
                                        <MDButton
                                            onClick={handleConfirmDeleteContacto}
                                            variant="gradient"
                                            color="error"
                                        >
                                            Eliminar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Objetos */}
                                <Dialog
                                    open={objetosDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseObjetosDialog(); }}
                                    maxWidth="md"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-objetos-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Objetos Completos
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDTypography variant="body2" color="text" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            <div dangerouslySetInnerHTML={{
                                                __html: (() => {
                                                    let texto = objetosDialog.contenido;
                                                    // Agregar espacio después de cada coma que está seguida de un número
                                                    texto = texto.replace(/,(\d)/g, ', $1');
                                                    // Agregar salto de línea después de punto y coma
                                                    texto = texto.replace(/;\s*/g, ';\n');
                                                    // Poner en negrita el texto descriptivo (palabras antes de "Cuenta n°")
                                                    texto = texto.replace(/^([^0-9\n]+)(Cuenta n°)/gm, '<span style="font-weight: 800; color: #1976d2;">$1</span>$2');
                                                    return texto;
                                                })()
                                            }} />
                                        </MDTypography>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton onClick={handleCloseObjetosDialog} color="info">
                                            Cerrar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Seguimiento */}
                                <Dialog
                                    open={seguimientoDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseSeguimiento(); }}
                                    fullWidth
                                    maxWidth="xl"
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-seguimiento-title" style={{ cursor: 'move' }}>
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                            <MDTypography variant="h5" fontWeight="bold">
                                                Seguimiento del Caso #{seguimientoDialog.idJudCaso}
                                            </MDTypography>
                                            <MDBox display="flex" gap={1}>
                                                <IconButton
                                                    onClick={handleImprimirSeguimiento}
                                                    color="primary"
                                                    disabled={seguimientoDialog.loading || seguimientoDialog.eventos.length === 0}
                                                    title="Imprimir"
                                                    size="small"
                                                >
                                                    <Print />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleOpenMailDialog}
                                                    color="info"
                                                    disabled={seguimientoDialog.loading || seguimientoDialog.eventos.length === 0}
                                                    title="Enviar por correo"
                                                    size="small"
                                                >
                                                    <EmailOutlined />
                                                </IconButton>
                                            </MDBox>
                                        </MDBox>
                                    </DialogTitle>
                                    <DialogContent>
                                        {seguimientoDialog.loading ? (
                                            <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                                <CircularProgress />
                                            </MDBox>
                                        ) : seguimientoDialog.eventos.length === 0 ? (
                                            <MDBox py={3} textAlign="center">
                                                <MDTypography variant="body2" color="text">
                                                    No hay eventos registrados para este caso
                                                </MDTypography>
                                            </MDBox>
                                        ) : (
                                            <MDBox sx={{ overflowX: 'auto' }}>
                                                <DataTable
                                                    table={{
                                                        columns: [
                                                            { Header: 'Fecha/Hora', accessor: 'fecha', align: 'left', width: '12%' },
                                                            { Header: 'Usuario', accessor: 'usuario', align: 'left', width: '12%' },
                                                            { Header: 'Tipo Evento', accessor: 'tipoEvento', align: 'left', width: '15%' },
                                                            { Header: 'Observaciones', accessor: 'observaciones', align: 'left', width: '37%' }
                                                        ],
                                                        rows: seguimientoDialog.eventos.map(evento => ({
                                                            fecha: (
                                                                <MDTypography variant="caption" color="text">
                                                                    {dayjs(evento.fecha).format('DD/MM/YYYY HH:mm:ss')}
                                                                </MDTypography>
                                                            ),
                                                            usuario: (
                                                                <MDTypography variant="caption" color="text">
                                                                    {evento.usuario}
                                                                </MDTypography>
                                                            ),
                                                            tipoEvento: (
                                                                <MDTypography variant="caption" color="text">
                                                                    {evento.tipoEvento}
                                                                </MDTypography>
                                                            ),
                                                            observaciones: (
                                                                <MDTypography variant="caption" color="text">
                                                                    {evento.observaciones || '-'}
                                                                </MDTypography>
                                                            )
                                                        }))
                                                    }}
                                                    entriesPerPage={{ defaultValue: 10, entries: [5, 10, 20, 50] }}
                                                    canSearch={false}
                                                    showTotalEntries={true}
                                                    isSorted={false}
                                                    noEndBorder={false}
                                                    pagination={{ variant: "gradient", color: "info" }}
                                                />
                                            </MDBox>
                                        )}
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="info" onClick={handleCloseSeguimiento}>
                                            Volver
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Mail */}
                                <Dialog
                                    open={mailDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseMailDialog(); }}
                                    maxWidth="md"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-mail-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Enviar Seguimiento por Correo - Caso #{mailDialog.idJudCaso}
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField
                                                label="Para *"
                                                type="email"
                                                value={mailDialog.para}
                                                onChange={(e) => setMailDialog({ ...mailDialog, para: e.target.value })}
                                                fullWidth
                                                placeholder="destinatario@ejemplo.com"
                                            />
                                            <TextField
                                                label="CC"
                                                type="email"
                                                value={mailDialog.cc}
                                                onChange={(e) => setMailDialog({ ...mailDialog, cc: e.target.value })}
                                                fullWidth
                                                placeholder="copia@ejemplo.com (opcional)"
                                            />
                                            <TextField
                                                label="Asunto *"
                                                value={mailDialog.asunto}
                                                onChange={(e) => setMailDialog({ ...mailDialog, asunto: e.target.value })}
                                                fullWidth
                                            />
                                            <TextField
                                                label="Cuerpo del mensaje *"
                                                multiline
                                                rows={6}
                                                value={mailDialog.cuerpo}
                                                onChange={(e) => setMailDialog({ ...mailDialog, cuerpo: e.target.value })}
                                                fullWidth
                                                placeholder="Escriba el mensaje aquí..."
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="error" onClick={handleCloseMailDialog} disabled={mailDialog.enviando}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="contained" color="success" onClick={handleEnviarMail} disabled={mailDialog.enviando}>
                                            {mailDialog.enviando ? <CircularProgress size={18} color="inherit" /> : "Enviar"}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Agregar Evento */}
                                <Dialog
                                    open={eventoDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseEvento(); }}
                                    maxWidth="sm"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-evento-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Agregar Evento - Caso #{eventoDialog.idJudCaso}
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <Autocomplete
                                                options={subEstados}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={eventoDialog.subEstado}
                                                onChange={(event, newValue) => handleSubEstadoChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Sub Estado *" placeholder="Seleccione un sub estado" />
                                                )}
                                                fullWidth
                                            />

                                            <Autocomplete
                                                options={eventoDialog.subEstado ? estados.filter(e => e.subEstado === eventoDialog.subEstado.label) : []}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={eventoDialog.estado}
                                                onChange={(event, newValue) => handleEstadoChange(newValue)}
                                                disabled={!eventoDialog.subEstado}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Estado *" placeholder="Seleccione un estado" />
                                                )}
                                                fullWidth
                                            />

                                            <Autocomplete
                                                options={tiposEventoJud}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={eventoDialog.tipoEvento}
                                                onChange={(event, newValue) => setEventoDialog({ ...eventoDialog, tipoEvento: newValue })}
                                                disabled={!eventoDialog.estado}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Tipo de Evento *" placeholder="Seleccione un tipo de evento" />
                                                )}
                                                fullWidth
                                            />

                                            <TextField
                                                label="Observaciones *"
                                                multiline
                                                rows={6}
                                                value={eventoDialog.observaciones}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 500) {
                                                        setEventoDialog({ ...eventoDialog, observaciones: e.target.value });
                                                    }
                                                }}
                                                fullWidth
                                                variant="outlined"
                                                helperText={`${eventoDialog.observaciones.length}/500 caracteres`}
                                                placeholder="Ingrese las observaciones del evento..."
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={eventoDialog.agendarLlamada}
                                                        onChange={(e) => setEventoDialog({ ...eventoDialog, agendarLlamada: e.target.checked })}
                                                        color="info"
                                                    />
                                                }
                                                label="Agendar llamada"
                                            />

                                            {eventoDialog.agendarLlamada && (
                                                <>
                                                    <MDTypography variant="caption" color="text" fontWeight="bold">
                                                        Sujeto: {eventoDialog.nombreSujeto}
                                                    </MDTypography>

                                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                        <DatePicker
                                                            label="Fecha de la llamada"
                                                            value={eventoDialog.fechaAgenda}
                                                            onChange={(newValue) => setEventoDialog({ ...eventoDialog, fechaAgenda: newValue })}
                                                            format="DD/MM/YYYY"
                                                            slotProps={{
                                                                textField: {
                                                                    fullWidth: true,
                                                                    variant: "outlined"
                                                                }
                                                            }}
                                                        />
                                                    </LocalizationProvider>

                                                    <TextField
                                                        label="Observaciones de la agenda"
                                                        multiline
                                                        rows={4}
                                                        value={eventoDialog.observacionesAgenda}
                                                        onChange={(e) => {
                                                            if (e.target.value.length <= 1000) {
                                                                setEventoDialog({ ...eventoDialog, observacionesAgenda: e.target.value });
                                                            }
                                                        }}
                                                        fullWidth
                                                        variant="outlined"
                                                        helperText={`${eventoDialog.observacionesAgenda.length}/1000 caracteres`}
                                                        placeholder="Observaciones para la agenda..."
                                                    />
                                                </>
                                            )}
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="error" onClick={handleCloseEvento} disabled={eventoDialog.guardando}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="contained" color="success" onClick={handleGuardarEvento} disabled={eventoDialog.guardando}>
                                            {eventoDialog.guardando ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Agenda */}
                                <Dialog
                                    open={agendaDialog.open}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseAgenda(); }}
                                    maxWidth="sm"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-agenda-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Agendar Llamada - Caso #{agendaDialog.idJudCaso}
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <MDBox>
                                                <MDTypography variant="caption" color="text" fontWeight="bold">
                                                    Sujeto: {agendaDialog.nombreSujeto}
                                                </MDTypography>
                                            </MDBox>

                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                <DatePicker
                                                    label="Fecha de la llamada"
                                                    value={agendaDialog.fecha}
                                                    onChange={(newValue) => setAgendaDialog({ ...agendaDialog, fecha: newValue })}
                                                    format="DD/MM/YYYY"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            variant: "outlined"
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>

                                            <TextField
                                                label="Observaciones"
                                                multiline
                                                rows={6}
                                                value={agendaDialog.observaciones}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 1000) {
                                                        setAgendaDialog({ ...agendaDialog, observaciones: e.target.value });
                                                    }
                                                }}
                                                fullWidth
                                                variant="outlined"
                                                helperText={`${agendaDialog.observaciones.length}/1000 caracteres`}
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="error" onClick={handleCloseAgenda} disabled={guardandoAgenda}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="contained" color="success" onClick={handleGuardarAgenda} disabled={guardandoAgenda}>
                                            {guardandoAgenda ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Notificaciones Agenda */}
                                <Dialog
                                    open={notificacionesDialog}
                                    onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseNotificaciones(); }}
                                    maxWidth="md"
                                    fullWidth
                                    disableEscapeKeyDown
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-notif-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Agendas
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={2}>
                                            <MDBox display="flex" gap={2} alignItems="center">
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                    <DatePicker
                                                        label="Fecha Desde"
                                                        value={agendaFilters.fechaDesde}
                                                        onChange={(newValue) => setAgendaFilters({ ...agendaFilters, fechaDesde: newValue })}
                                                        format="DD/MM/YYYY"
                                                        slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                                    />
                                                    <DatePicker
                                                        label="Fecha Hasta"
                                                        value={agendaFilters.fechaHasta}
                                                        onChange={(newValue) => setAgendaFilters({ ...agendaFilters, fechaHasta: newValue })}
                                                        format="DD/MM/YYYY"
                                                        slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                                    />
                                                </LocalizationProvider>
                                                <MDButton variant="contained" color="info" onClick={handleBuscarAgendas}>
                                                    Buscar
                                                </MDButton>
                                            </MDBox>

                                            <TextField
                                                label="Filtrar por Nombre Sujeto"
                                                name="nombreSujeto"
                                                value={agendaFilters.nombreSujeto}
                                                onChange={handleAgendaFilterChange}
                                                fullWidth
                                                size="small"
                                            />

                                            {loadingAgendas ? (
                                                <MDBox display="flex" justifyContent="center" py={3}>
                                                    <CircularProgress />
                                                </MDBox>
                                            ) : agendasFiltradas.length === 0 ? (
                                                <MDBox py={3} textAlign="center">
                                                    <MDTypography variant="body2" color="text">
                                                        No hay agendas para mostrar
                                                    </MDTypography>
                                                </MDBox>
                                            ) : (
                                                <List sx={{ maxHeight: 400, overflowY: 'auto', overflowX: 'hidden' }}>
                                                    {agendasFiltradas.map((agenda, index) => (
                                                        <div key={agenda.idCasoAgenda}>
                                                            <ListItem
                                                                sx={{
                                                                    backgroundColor: agenda.visto ? 'transparent' : '#e3f2fd',
                                                                    '&:hover': { backgroundColor: '#f5f5f5' },
                                                                    py: 0.5
                                                                }}
                                                                secondaryAction={
                                                                    <IconButton
                                                                        edge="end"
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (!agenda.visto) {
                                                                                handleMarcarVisto(agenda.idAgenda);
                                                                            }
                                                                        }}
                                                                        disabled={agenda.visto}
                                                                        sx={{
                                                                            color: agenda.visto ? 'success.main' : 'warning.main',
                                                                            '&:hover': !agenda.visto ? { backgroundColor: 'rgba(237, 108, 2, 0.08)' } : {},
                                                                            cursor: agenda.visto ? 'default' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {agenda.visto ? (
                                                                            <CheckCircle fontSize="small" />
                                                                        ) : (
                                                                            <RadioButtonUnchecked fontSize="small" />
                                                                        )}
                                                                    </IconButton>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={
                                                                        <MDBox>
                                                                            <MDTypography variant="caption" fontWeight="bold" sx={{ fontSize: '0.813rem' }}>
                                                                                {agenda.nombreSujeto}
                                                                            </MDTypography>
                                                                            <MDTypography variant="caption" color="text" sx={{ fontSize: '0.75rem' }}>
                                                                                <br />
                                                                                <Chip size="small" variant="outlined" color="info" label={etiquetaTipoCaso(agenda.tipo)} sx={{ mr: 0.5, height: 18, fontSize: '0.65rem' }} />
                                                                                Caso #{agenda.idCaso} - Fecha Agendada: {dayjs(agenda.fecha).format('DD/MM/YYYY')}
                                                                            </MDTypography>
                                                                        </MDBox>
                                                                    }
                                                                    secondary={
                                                                        <MDTypography
                                                                            variant="caption"
                                                                            color="text"
                                                                            sx={{
                                                                                fontSize: '0.75rem',
                                                                                display: '-webkit-box',
                                                                                WebkitLineClamp: 2,
                                                                                WebkitBoxOrient: 'vertical',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis'
                                                                            }}
                                                                        >
                                                                            {agenda.observaciones}
                                                                        </MDTypography>
                                                                    }
                                                                />
                                                            </ListItem>
                                                            {index < agendasFiltradas.length - 1 && <Divider />}
                                                        </div>
                                                    ))}
                                                </List>
                                            )}
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="contained" color="info" onClick={handleCloseNotificaciones}>
                                            Cerrar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Edit Expediente Field */}
                                <Dialog
                                    open={editExpedienteDialog.open}
                                    onClose={handleCloseEditExpediente}
                                    PaperComponent={PaperComponent}
                                    maxWidth="sm"
                                    fullWidth
                                    aria-labelledby="edit-expediente-dialog-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="edit-expediente-dialog-title">
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                            <MDTypography variant="h5" fontWeight="bold">
                                                Editar {editExpedienteDialog.fieldLabel}
                                            </MDTypography>
                                            <IconButton onClick={handleCloseEditExpediente} size="small">
                                                <CloseIcon />
                                            </IconButton>
                                        </MDBox>
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDBox pt={2}>
                                            <TextField
                                                fullWidth
                                                label={editExpedienteDialog.fieldLabel}
                                                value={editExpedienteDialog.fieldValue}
                                                onChange={(e) => setEditExpedienteDialog(prev => ({ ...prev, fieldValue: e.target.value }))}
                                                type={editExpedienteDialog.fieldType === "decimal" ? "number" : "text"}
                                                inputProps={editExpedienteDialog.fieldType === "decimal" ? { step: "0.01" } : {}}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton
                                            variant="outlined"
                                            color="secondary"
                                            onClick={handleCloseEditExpediente}
                                            disabled={editExpedienteDialog.saving}
                                        >
                                            Cancelar
                                        </MDButton>
                                        <MDButton
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveEditExpediente}
                                            disabled={editExpedienteDialog.saving}
                                        >
                                            {editExpedienteDialog.saving ? <CircularProgress size={20} color="inherit" /> : 'Guardar'}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Diálogo de Alertas */}
                                <Dialog
                                    open={openAlertDialog}
                                    onClose={handleCloseAlertDialog}
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="alert-dialog-title"
                                    maxWidth="lg"
                                    fullWidth
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="alert-dialog-title">
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                            <MDTypography variant="h6">
                                                {alertDialogType === 'rojo' && '🔴 Alertas Vencidas (Fuera de Plazo)'}
                                                {alertDialogType === 'amarillo' && '🟡 Vence Hoy / Próximo a Vencer (1 día o menos)'}
                                                {alertDialogType === 'verde' && '🟢 En Plazo (Más de 2 días para vencer)'}
                                            </MDTypography>
                                            <IconButton onClick={handleCloseAlertDialog}>
                                                <CloseIcon />
                                            </IconButton>
                                        </MDBox>
                                    </DialogTitle>
                                    <DialogContent>
                                        {/* Filtros locales */}
                                        <MDBox mb={3} display="flex" gap={2} flexWrap="wrap">
                                            <MDInput
                                                label="Filtrar por Nombre"
                                                type="text"
                                                value={alertFiltroNombre}
                                                onChange={(e) => setAlertFiltroNombre(e.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                            <MDInput
                                                label="Filtrar por Identificación"
                                                type="text"
                                                value={alertFiltroIdentificacion}
                                                onChange={(e) => setAlertFiltroIdentificacion(e.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                            <MDInput
                                                label="Filtrar por Expediente"
                                                type="text"
                                                value={alertFiltroExpediente}
                                                onChange={(e) => setAlertFiltroExpediente(e.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                        </MDBox>
                                        <DataTable
                                            table={{
                                                columns: [
                                                    {
                                                        Header: "Acción",
                                                        accessor: "accion",
                                                        width: "5%",
                                                        Cell: ({ row }) => (
                                                            <Tooltip title="Filtrar por este caso" placement="top">
                                                                <IconButton
                                                                    size="small"
                                                                    color="info"
                                                                    onClick={() => handleFiltrarPorCaso(row.original.idJudCaso)}
                                                                    sx={{
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(25, 118, 210, 0.1)'
                                                                        }
                                                                    }}
                                                                >
                                                                    <SearchIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )
                                                    },
                                                    {
                                                        Header: "#Caso",
                                                        accessor: "idJudCaso",
                                                        width: "7%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {row.original.idJudCaso}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    },
                                                    {
                                                        Header: "Nombre",
                                                        accessor: "nombreSujeto",
                                                        width: "15%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {row.original.nombreSujeto || "-"}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    },
                                                    {
                                                        Header: "Identificación",
                                                        accessor: "identificacion",
                                                        width: "10%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {row.original.identificacion || "-"}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    },
                                                    {
                                                        Header: "Expediente",
                                                        accessor: "expedienteJudicial",
                                                        width: "10%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {row.original.expedienteJudicial || "-"}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    },
                                                    {
                                                        Header: "Tipo de Evento",
                                                        accessor: "tipoEvento",
                                                        width: "33%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {row.original.tipoEvento}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    },
                                                    {
                                                        Header: "Fecha Plazo",
                                                        accessor: "fechaPlazo",
                                                        width: "20%",
                                                        Cell: ({ row }) => {
                                                            const fechaPlazo = dayjs(row.original.fechaPlazoOriginal);
                                                            const hoy = dayjs();
                                                            const isVencido = fechaPlazo.isBefore(hoy, 'day');
                                                            return (
                                                                <MDTypography variant="caption" color={isVencido ? "error" : "text"} fontWeight={isVencido ? "bold" : "regular"}>
                                                                    {fechaPlazo.format('DD/MM/YYYY')}
                                                                </MDTypography>
                                                            );
                                                        }
                                                    }
                                                ],
                                                rows: alertDialogData.map(alerta => ({
                                                    idJudCaso: alerta.idJudCaso,
                                                    nombreSujeto: alerta.nombreSujeto,
                                                    identificacion: alerta.identificacion,
                                                    expedienteJudicial: alerta.expedienteJudicial,
                                                    tipoEvento: alerta.tipoEvento,
                                                    fechaPlazo: dayjs(alerta.fechaPlazo).format('DD/MM/YYYY'),
                                                    fechaPlazoOriginal: alerta.fechaPlazo
                                                }))
                                            }}
                                            isSorted={false}
                                            entriesPerPage={false}
                                            showTotalEntries={true}
                                            noEndBorder
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton onClick={handleCloseAlertDialog} color="secondary" variant="gradient">
                                            Cerrar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Cambiar Gestor */}
                                <Dialog 
                                    open={cambiarGestorDialog.open} 
                                    onClose={(event, reason) => { 
                                        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') 
                                            handleCloseCambiarGestor(); 
                                    }} 
                                    maxWidth="sm" 
                                    fullWidth 
                                    disableEscapeKeyDown 
                                    PaperComponent={PaperComponent}
                                >
                                    <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            Cambiar Gestor - Caso Judicial #{cambiarGestorDialog.idJudCaso}
                                        </MDTypography>
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <MDBox display="flex" flexDirection="column" gap={2} py={2}>
                                            <MDBox>
                                                <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
                                                    Gestor Actual:
                                                </MDTypography>
                                                <MDTypography variant="body2" color="info" fontWeight="medium">
                                                    {cambiarGestorDialog.usuarioActual}
                                                </MDTypography>
                                            </MDBox>

                                            <Autocomplete
                                                options={usuarios}
                                                getOptionLabel={(option) => option.label || ""}
                                                getOptionDisabled={(option) => !option.activo}
                                                value={cambiarGestorDialog.selectedUsuario}
                                                onChange={(event, newValue) => {
                                                    setCambiarGestorDialog(prev => ({ ...prev, selectedUsuario: newValue }));
                                                }}
                                                renderInput={(params) => <TextField {...params} label="Nuevo Gestor *" />}
                                                fullWidth
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton 
                                            onClick={handleCloseCambiarGestor} 
                                            color="secondary" 
                                            disabled={cambiarGestorDialog.guardando}
                                        >
                                            Cancelar
                                        </MDButton>
                                        <MDButton 
                                            onClick={handleAceptarCambiarGestor} 
                                            color="info" 
                                            disabled={cambiarGestorDialog.guardando || !cambiarGestorDialog.selectedUsuario}
                                        >
                                            {cambiarGestorDialog.guardando ? 'Guardando...' : 'Aceptar'}
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default JudCasoListar;
